{
  "account.account": "Προφίλ και ασφάλεια",
  "account.accountDeleted": "Ο λογαριασμός σας διαγράφηκε επιτυχώς.",
  "account.accountDescription": "Όνομα, κωδικός πρόσβασης, διαγραφή λογαριασμού",
  "account.accountSection": "Λογαριασμός",
  "account.changeEmail": "Αλλαγή email",
  "account.changePassword": "Αλλαγή κωδικού πρόσβασης",
  "account.currentPassword": "Τρέχων κωδικός πρόσβασης",
  "account.dangerZone": "Ζώνη κινδύνου",
  "account.deleteAccount": "Διαγραφή του λογαριασμού σας",
  "account.deleteAccountConfirmation": "Είστε σίγουροι ότι θέλετε να διαγράψετε τον λογαριασμό σας; Αυτή η ενέργεια είναι μη αναστρέψιμη.",
  "account.deleteAccountDescription": "Αυτή η ενέργεια διαγράφει τον λογαριασμό σας και όλες τις πληροφορίες σας. Δεν υπάρχει επιστροφή.",
  "account.emailChange": "Αλλαγή διεύθυνσης email",
  "account.emailChangeConfirmation": "Επιβεβαίωση αλλαγής email",
  "account.emailChangeFailure": "Ο σύνδεσμος αλλαγής email δεν είναι έγκυρος ή έχει λήξει.",
  "account.emailChangeIntro": "Εισαγάγετε τη νέα σας διεύθυνση email και τον τρέχοντα κωδικό πρόσβασης. Θα στείλουμε έναν σύνδεσμο στη νέα διεύθυνση: το email σας θα αλλάξει μόνο όταν τον ανοίξετε.",
  "account.emailChangeSuccess": "Το email σας άλλαξε επιτυχώς σε {newEmail}.",
  "account.emailChangeSuccessNoAddress": "Η διεύθυνση email σας άλλαξε επιτυχώς.",
  "account.emailChangeVerificationSent": "Ένα email επιβεβαίωσης στάλθηκε στη νέα σας διεύθυνση email. Ελέγξτε τα εισερχόμενά σας και κάντε κλικ στον σύνδεσμο για να επιβεβαιώσετε την αλλαγή.",
  "account.manageAccount": "Διαχείριση λογαριασμού",
  "account.newEmailAddress": "Νέα διεύθυνση email",
  "account.newPassword": "Νέος κωδικός πρόσβασης",
  "account.newPasswordAgain": "Νέος κωδικός πρόσβασης, επιβεβαίωση",
  "account.oldPassword": "Παλιός κωδικός πρόσβασης",
  "account.passwordChange": "Αλλαγή κωδικού πρόσβασης",
  "account.passwordChangeDescription": "Διατηρήστε τον λογαριασμό σας ασφαλή",
  "account.passwordUpdated": "Ο κωδικός πρόσβασης ενημερώθηκε με επιτυχία.",
  "account.profile": "Προφίλ",
  "account.profileUpdated": "Το προφίλ ενημερώθηκε με επιτυχία.",
  "account.signedInAs": "Συνδεδεμένος ως",
  "account.updateYourProfile": "Ενημερώστε το προφίλ σας",
  "account.updateYourProfileDescription": "Όνομα και προτιμήσεις εμφάνισης",
  "addons.accountOnHold": "Η σύνδεση του λογαριασμού σας έχει λήξει. Επανασυνδεθείτε για να συνεχιστούν οι ενημερώσεις δεδομένων.",
  "addons.accountOnHoldTitle": "Λογαριασμός σε αναστολή",
  "addons.ambientWeatherCreateAndRetrieveApiKey": "Δημιουργήστε και ανακτήστε το κλειδί API από αυτόν τον σύνδεσμο",
  "addons.ambientWeatherDescription": "Μετεωρολογικοί σταθμοί Ambient Weather (WS-5000, WS-2000, WS-2902C,...)",
  "addons.apiKey": "Κλειδί API",
  "addons.applicationKey": "Κλειδί εφαρμογής",
  "addons.availableServices": "Διαθέσιμες",
  "addons.cannotDisconnectLastAccount": "Δεν είναι δυνατή η αποσύνδεση της μοναδικής μεθόδου σύνδεσης. Προσθέστε πρώτα μια άλλη μέθοδο σύνδεσης.",
  "addons.connect": "Σύνδεση",
  "addons.connected": "Συνδεδεμένο",
  "addons.connectedAccounts": "Συνδεδεμένοι λογαριασμοί",
  "addons.connectedAccountsDescription": "Apple, Google, Facebook",
  "addons.connectedServices": "Συνδεδεμένες",
  "addons.connectedSince": "Συνδεδεμένο από {date}",
  "addons.connectionSection": "Σύνδεση",
  "addons.connectionSuccess": "Ο λογαριασμός {provider} συνδέθηκε επιτυχώς",
  "addons.davisApiSecret": "Κωδικός API",
  "addons.davisApiV2Key": "Κλειδί V2 API",
  "addons.davisDescription": "Μετεωρολογικοί σταθμοί Davis (Vantage Vue, Vantage Pro2, ...)",
  "addons.davisRetrieveApiKey": "Ανακτήστε τα κλειδιά V2 API από αυτόν τον σύνδεσμο",
  "addons.disconnect": "Αποσύνδεση",
  "addons.disconnectConfirmation": "Είστε βέβαιοι ότι θέλετε να αποσυνδέσετε τον λογαριασμό {provider};",
  "addons.disconnectionSuccess": "Ο λογαριασμός {provider} αποσυνδέθηκε επιτυχώς",
  "addons.disconnectProviderDescription": "Σταματά τον συγχρονισμό. Το ιστορικό σας διατηρείται.",
  "addons.ecowittCreateAndRetrieveKeys": "Δημιουργήστε και ανακτήστε ένα κλειδί API και ένα κλειδί εφαρμογής από αυτόν τον σύνδεσμο",
  "addons.ecowittDescription": "Η Ecowitt παρέχει επαγγελματικούς μετεωρολογικούς σταθμούς wifi, ασύρματα θερμόμετρα εσωτερικού και εξωτερικού χώρου, μετρητές υγρασίας, βροχομετρητές υψηλής ακρίβειας, μετρητές ποιότητας αέρα και πολλά άλλα.",
  "addons.helpLink": "Πώς να συνδέσετε το {provider}",
  "addons.integrationsSection": "Ενσωματώσεις",
  "addons.myAcuriteAccountOnHold": "Ο λογαριασμός σας έχει τεθεί σε αναμονή. Παρακαλούμε εισάγετε τον κωδικό πρόσβασής σας για να επανασυνδέσετε το λογαριασμό σας",
  "addons.myAcuriteDescription": "Η AcuRite είναι η πρωτοπόρα μάρκα μετεωρολογικών σταθμών στη Βόρεια Αμερική. Ως ηγέτης στην τεχνολογία χρόνου, θερμοκρασίας και καιρού, η AcuRite σας παρέχει λεπτομερείς πληροφορίες για το εσωτερικό και το εξωτερικό σας περιβάλλον, ώστε να μπορείτε να σχεδιάζετε την ημέρα σας με σιγουριά.",
  "addons.netatmoEnergy": "Netatmo Energy",
  "addons.netatmoEnergyDescription": "Χρησιμοποιήστε τον θερμοστάτη Netatmo για να αλλάξετε τη θερμοκρασία του σπιτιού σας, από το κρεβάτι σας ή από την άλλη άκρη του κόσμου",
  "addons.netatmoWeather": "Netatmo Weather",
  "addons.netatmoWeatherDescription": "Ο προσωπικός σας μετεωρολογικός σταθμός στο σπίτι.",
  "addons.notConnected": "Δεν είναι συνδεδεμένο",
  "addons.or": "ή",
  "addons.providerAccountDisconnected": "Η σύνδεση με την υπηρεσία καιρού σας έχει λήξει. Επανασυνδεθείτε για να συνεχιστούν οι ενημερώσεις δεδομένων.",
  "addons.reconnect": "Επανασύνδεση",
  "addons.socialConnectionsIntro": "Συνδέστε τους κοινωνικούς σας λογαριασμούς για γρήγορη σύνδεση. Μπορείτε να συνδέσετε ή να αποσυνδέσετε λογαριασμούς ανά πάσα στιγμή.",
  "addons.weatherflowCreateToken": "Δημιουργήστε και ανακτήστε το διακριτικό σας (token) από αυτόν τον σύνδεσμο",
  "addons.weatherflowTempestDescription": "Σύστημα καιρού Tempest με ενσωματωμένους μετρητές ανέμου και βροχής.",
  "addons.weatherServices": "Μετεωρολογικές υπηρεσίες",
  "addons.weatherServicesConnected": "{count, plural, =0 {Καμία υπηρεσία συνδεδεμένη} one {# υπηρεσία συνδεδεμένη} other {# υπηρεσίες συνδεδεμένες}}",
  "addons.weatherServicesDescription": "Συνδέστε Netatmo, Davis, Weatherflow και άλλα",
  "addons.wundergroundApiKey": "Κλειδί API",
  "addons.wundergroundDescription": "Το Weather Underground είναι μια παγκόσμια κοινότητα ανθρώπων που συνδέει δεδομένα από περιβαλλοντικούς αισθητήρες, όπως μετεωρολογικούς σταθμούς και όργανα παρακολούθησης της ποιότητας του αέρα, ώστε να μπορούμε να παρέχουμε τα πλούσια, υπερτοπικά δεδομένα που χρειάζεστε για να ενισχύσετε τα ενδιαφέροντά σας.",
  "addons.wundergroundRetrieveApiKey": "Ανακτήστε το κλειδί σας API από αυτόν τον σύνδεσμο",
  "addons.wundergroundStationId": "Ταυτότητα σταθμού",
  "airQuality.adviceActivityGood": "Ιδανική μέρα για δραστηριότητες σε εξωτερικό χώρο",
  "airQuality.adviceActivityHazardous": "Αποφύγετε κάθε σωματική δραστηριότητα σε εξωτερικό χώρο",
  "airQuality.adviceActivityLabel": "Σωματική δραστηριότητα",
  "airQuality.adviceActivityModerate": "Καλή μέρα για δραστηριότητες σε εξωτερικό χώρο",
  "airQuality.adviceActivitySensitive": "Σκεφτείτε να κάνετε συντομότερες και λιγότερο έντονες δραστηριότητες σε εξωτερικό χώρο",
  "airQuality.adviceActivityUnhealthy": "Μειώστε τις παρατεταμένες ή έντονες δραστηριότητες και κάντε περισσότερα διαλείμματα",
  "airQuality.adviceActivityVeryUnhealthy": "Αποφύγετε τις παρατεταμένες ή έντονες δραστηριότητες· εξετάστε τη μεταφορά τους σε εσωτερικό χώρο",
  "airQuality.adviceGroupsGood": "Δεν χρειάζονται ιδιαίτερες προφυλάξεις",
  "airQuality.adviceGroupsHazardous": "Μείνετε σε εσωτερικό χώρο και περιορίστε τη δραστηριότητα",
  "airQuality.adviceGroupsLabel": "Ευαίσθητες ομάδες",
  "airQuality.adviceGroupsModerate": "Ιδιαίτερα ευαίσθητα άτομα: συντομότερες και λιγότερο έντονες δραστηριότητες",
  "airQuality.adviceGroupsSensitive": "Συντομότερες και λιγότερο έντονες δραστηριότητες σε εξωτερικό χώρο, με περισσότερα διαλείμματα",
  "airQuality.adviceGroupsUnhealthy": "Αποφύγετε παρατεταμένες ή έντονες δραστηριότητες σε εξωτερικό χώρο· καλύτερα σε εσωτερικό χώρο",
  "airQuality.adviceGroupsVeryUnhealthy": "Αποφύγετε κάθε σωματική δραστηριότητα σε εξωτερικό χώρο· αναβάλετέ την ή μεταφέρετέ την σε εσωτερικό χώρο",
  "airQuality.adviceTimingLabel": "Πότε να βγείτε έξω",
  "airQuality.adviceTimingMorning": "Κατά προτίμηση το πρωί — τότε το όζον είναι χαμηλότερο",
  "airQuality.airQuality": "Ποιότητα αέρα",
  "airQuality.airQualityIndex": "Δείκτης ποιότητας αέρα",
  "airQuality.aqiForecast": "Πρόγνωση ποιότητας αέρα",
  "airQuality.co2Fresh": "Φρέσκος",
  "airQuality.co2GettingStale": "Ελαφρώς αποπνικτικός",
  "airQuality.co2Stale": "Αποπνικτικός",
  "airQuality.dailyForecast": "Ημερήσια πρόγνωση",
  "airQuality.dominantPollutant": "Κυρίαρχος ρύπος",
  "airQuality.expectedPeak": "Αναμενόμενη αιχμή",
  "airQuality.good": "Καλός",
  "airQuality.goodDescription": "Η ποιότητα του αέρα θεωρείται ικανοποιητική και η ατμοσφαιρική ρύπανση αποτελεί μικρό ή μηδενικό ρίσκο.",
  "airQuality.hazardous": "Επικίνδυνος για την υγεία",
  "airQuality.hazardousDescription": "Υγειονομικός συναγερμός: οποιοσδήποτε μπορεί να παρουσιάσει σοβαρά προβλήματα υγείας.",
  "airQuality.indoorAirQuality": "Ποιότητα αέρα εσωτερικού χώρου",
  "airQuality.moderate": "Μέτριος",
  "airQuality.moderateDescription": "Η ποιότητα του αέρα είναι αποδεκτή. Ωστόσο, ορισμένοι ρύποι μπορεί να δημιουργούν ανησυχία για την υγεία ενός πολύ μικρού αριθμού ανθρώπων που είναι ασυνήθιστα ευαίσθητοι στην ατμοσφαιρική ρύπανση.",
  "airQuality.noForecastForLocation": "Δεν υπάρχει διαθέσιμη πρόγνωση ποιότητας αέρα για αυτήν την τοποθεσία.",
  "airQuality.now": "Τώρα",
  "airQuality.nowCastAqi": "NowCast AQI",
  "airQuality.pollutants": "Ρύποι",
  "airQuality.recommendations": "Συστάσεις",
  "airQuality.sensitiveUnhealthy": "Ανθυγιεινός για ευαίσθητες ομάδες",
  "airQuality.sensitiveUnhealthyDescription": "Μέλη ευαίσθητων ομάδων ενδέχεται να έχουν επιπτώσεις στην υγεία. Το ευρύ κοινό δεν είναι πιθανό να επηρεαστεί.",
  "airQuality.subIndex": "Υποδείκτης AQI",
  "airQuality.ugm3": "µg/m³",
  "airQuality.understandIndex": "Κατανόηση του δείκτη",
  "airQuality.unhealthy": "Ανθυγιεινός",
  "airQuality.unhealthyDescription": "Όλοι μπορεί να αρχίσουν να έχουν επιπτώσεις στην υγεία· τα μέλη ευαίσθητων ομάδων μπορεί να παρουσιάσουν σοβαρότερες επιπτώσεις.",
  "airQuality.veryUnhealthy": "Πολύ ανθυγιεινός",
  "airQuality.veryUnhealthyDescription": "Προειδοποιήσεις υγείας για καταστάσεις έκτακτης ανάγκης. Όλος ο πληθυσμός είναι πιθανόν να επηρεαστεί.",
  "alerts.addAlert": "Προσθήκη ειδοποίησης",
  "alerts.addCondition": "Προσθήκη συνθήκης",
  "alerts.alertAdded": "Η ειδοποίηση προστέθηκε επιτυχώς",
  "alerts.alertAuthorizationNotice": "Οι ειδοποιήσεις λειτουργούν μόνο εάν δώσετε άδεια στο SmartMixin να εμφανίζει ειδοποιήσεις.",
  "alerts.alertDeleted": "Η ειδοποίηση διαγράφηκε με επιτυχία",
  "alerts.alertName": "Όνομα ειδοποίησης",
  "alerts.alertWhen": "Θέλω να ειδοποιηθώ όταν:",
  "alerts.aqiGreaterThan": "AQI μεγαλύτερος από",
  "alerts.aqiGreaterThanThreshold": "AQI μεγαλύτερος από το όριο {value}{unit}",
  "alerts.aqiLessThan": "AQI μικρότερος από",
  "alerts.aqiLessThanThreshold": "AQI μικρότερος από το όριο {value}{unit}",
  "alerts.atLeastOneCondition": "Πρέπει να προσθέσετε τουλάχιστον μία συνθήκη",
  "alerts.co2GreaterThan": "CO2 μεγαλύτερο από",
  "alerts.co2GreaterThanThreshold": "CO2 μεγαλύτερο από το όριο {value}{unit}",
  "alerts.co2LessThan": "CO2 μικρότερο από",
  "alerts.co2LessThanThreshold": "CO2 μικρότερο από το όριο {value}{unit}",
  "alerts.conditions": "Συνθήκες",
  "alerts.conditionsDroppedOnStationChange": "Δεν υποστηρίζονται από αυτόν τον σταθμό και αφαιρέθηκαν: {conditions}",
  "alerts.createAlert": "Δημιουργία ειδοποίησης",
  "alerts.dailyPrecipitationGreaterThan": "Ημερήσιος υετός μεγαλύτερος από",
  "alerts.dailyPrecipitationGreaterThanThreshold": "Ημερήσιος υετός πάνω από το όριο {value}{unit}",
  "alerts.deleteAlert": "Διαγραφή ειδοποίησης",
  "alerts.editAlert": "Επεξεργασία ειδοποίησης",
  "alerts.editCondition": "Επεξεργασία συνθήκης",
  "alerts.gustSpeedGreaterThan": "Ταχύτητα ριπής μεγαλύτερη από",
  "alerts.gustSpeedGreaterThanThreshold": "Ταχύτητα ριπής μεγαλύτερη από το όριο {value}{unit}",
  "alerts.gustSpeedLessThan": "Ταχύτητα ριπής μικρότερη από",
  "alerts.gustSpeedLessThanThreshold": "Ταχύτητα ριπής μικρότερη από το όριο {value}{unit}",
  "alerts.heatIndexGreaterThan": "Δείκτης θερμότητας μεγαλύτερος από",
  "alerts.heatIndexGreaterThanThreshold": "Δείκτης θερμότητας μεγαλύτερος από το όριο {value}{unit}",
  "alerts.heatIndexLessThan": "Δείκτης θερμότητας μικρότερος από",
  "alerts.heatIndexLessThanThreshold": "Δείκτης θερμότητας μικρότερος από το όριο {value}{unit}",
  "alerts.humidexGreaterThan": "Δείκτης δυσφορίας Humidex μεγαλύτερος από",
  "alerts.humidexGreaterThanThreshold": "Δείκτης δυσφορίας Humidex μεγαλύτερος από το όριο {value}{unit}",
  "alerts.humidexLessThan": "Δείκτης δυσφορίας Humidex μικρότερος από",
  "alerts.humidexLessThanThreshold": "Δείκτης δυσφορίας Humidex μικρότερος από το όριο {value}{unit}",
  "alerts.humidityGreaterThan": "Υγρασία αέρα μεγαλύτερη από",
  "alerts.humidityGreaterThanThreshold": "Υγρασία αέρα μεγαλύτερη από το όριο {value}{unit}",
  "alerts.humidityLessThan": "Υγρασία αέρα μικρότερη από",
  "alerts.humidityLessThanThreshold": "Υγρασία αέρα μικρότερη από το όριο {value}{unit}",
  "alerts.inProgress": "Σε εξέλιξη",
  "alerts.leafWetnessGreaterThan": "Υγρασία φύλλων μεγαλύτερη από",
  "alerts.leafWetnessGreaterThanThreshold": "Υγρασία φύλλων μεγαλύτερη από το όριο {value}{unit}",
  "alerts.leafWetnessLessThan": "Υγρασία φύλλων μικρότερη από",
  "alerts.leafWetnessLessThanThreshold": "Υγρασία φύλλων μικρότερη από το όριο {value}{unit}",
  "alerts.myAlerts": "Οι ειδοποιήσεις μου",
  "alerts.noConfiguredAlert": "Δεν έχετε ρυθμίσει ακόμα καμία ειδοποίηση, ξεκινήστε να προσθέσετε μία.",
  "alerts.noiseGreaterThan": "Θόρυβος μεγαλύτερος από",
  "alerts.noiseGreaterThanThreshold": "Θόρυβος μεγαλύτερος από το όριο {value}{unit}",
  "alerts.noiseLessThan": "Θόρυβος λιγότερο από",
  "alerts.noiseLessThanThreshold": "Θόρυβος μικρότερος από το όριο {value}{unit}",
  "alerts.noteOnConditions": "Σημειώστε ότι η ειδοποίηση ενεργοποιείται όταν επαληθευτούν όλες οι παρακάτω συνθήκες",
  "alerts.noTriggerHistory": "Αυτή η ειδοποίηση δεν έχει ενεργοποιηθεί ακόμη.",
  "alerts.pm10GreaterThan": "PM 10 μεγαλύτερο από",
  "alerts.pm10GreaterThanThreshold": "PM 10 μεγαλύτερο από το όριο {value}{unit}",
  "alerts.pm10LessThan": "PM 10 μικρότερο από",
  "alerts.pm10LessThanThreshold": "PM 10 μικρότερο από το όριο {value}{unit}",
  "alerts.pm1GreaterThan": "PM 1 μεγαλύτερο από",
  "alerts.pm1GreaterThanThreshold": "PM 1 μεγαλύτερο από το όριο {value}{unit}",
  "alerts.pm1LessThan": "PM 1 μικρότερο από",
  "alerts.pm1LessThanThreshold": "PM 1 μικρότερο από το όριο {value}{unit}",
  "alerts.pm2p5GreaterThan": "PM 2,5 μεγαλύτερο από",
  "alerts.pm2p5GreaterThanThreshold": "PM 2,5 μεγαλύτερο από το όριο {value}{unit}",
  "alerts.pm2p5LessThan": "PM 2,5 μικρότερο από",
  "alerts.pm2p5LessThanThreshold": "PM 2,5 μικρότερο από το όριο {value}{unit}",
  "alerts.postStormSummary": "Σύνοψη καταιγίδας",
  "alerts.postStormSynopsisHelper": "Θα λαμβάνετε μια ειδοποίηση σύνοψης μετά το τέλος κάθε βροχόπτωσης.",
  "alerts.postStormSynopsisSoleCondition": "Μια σύνοψη μετά την καταιγίδα δεν μπορεί να συνδυαστεί με άλλες συνθήκες.",
  "alerts.precipitationGreaterThan": "Ωριαίος υετός μεγαλύτερος από",
  "alerts.precipitationGreaterThanThreshold": "Ωριαίος υετός πάνω από το όριο {value}{unit}",
  "alerts.pressureGreaterThan": "Πίεση μεγαλύτερη από",
  "alerts.pressureGreaterThanThreshold": "Πίεση μεγαλύτερη από το όριο {value}{unit}",
  "alerts.pressureLessThan": "Πίεση μικρότερη από",
  "alerts.pressureLessThanThreshold": "Πίεση μικρότερη από το όριο {value}{unit}",
  "alerts.rainRateGreaterThan": "Ένταση βροχής μεγαλύτερη από",
  "alerts.rainRateGreaterThanThreshold": "Ένταση βροχής πάνω από το όριο {value}{unit}",
  "alerts.sensorNotReporting": "Αυτός ο αισθητήρας δεν στέλνει δεδομένα αυτή τη στιγμή. Η ειδοποίηση θα συνεχιστεί μόλις ξαναρχίσει να στέλνει.",
  "alerts.soilMoistureGreaterThan": "Υγρασία εδάφους μεγαλύτερη από",
  "alerts.soilMoistureGreaterThanThreshold": "Υγρασία εδάφους μεγαλύτερη από το όριο {value}{unit}",
  "alerts.soilMoistureLessThan": "Υγρασία εδάφους μικρότερη από",
  "alerts.soilMoistureLessThanThreshold": "Υγρασία εδάφους μικρότερη από το όριο {value}{unit}",
  "alerts.solarRadiationGreaterThan": "Ηλιακή ακτινοβολία μεγαλύτερη από",
  "alerts.solarRadiationGreaterThanThreshold": "Ηλιακή ακτινοβολία μεγαλύτερη από το όριο {value}{unit}",
  "alerts.solarRadiationLessThan": "Ηλιακή ακτινοβολία μικρότερη από",
  "alerts.solarRadiationLessThanThreshold": "Ηλιακή ακτινοβολία μικρότερη από το όριο {value}{unit}",
  "alerts.stormChartUnavailable": "Το ιστορικό βροχής για αυτήν την καταιγίδα δεν είναι διαθέσιμο.",
  "alerts.stormDetail": "Σύνοψη καταιγίδας",
  "alerts.stormDuration": "Διάρκεια",
  "alerts.stormEnd": "Λήξη",
  "alerts.stormPeakRate": "Μέγιστη ένταση βροχής",
  "alerts.stormStart": "Έναρξη",
  "alerts.stormTotal": "Συνολική βροχόπτωση",
  "alerts.temperatureGreaterThan": "Θερμοκρασία μεγαλύτερη από",
  "alerts.temperatureGreaterThanThreshold": "Θερμοκρασία μεγαλύτερη από το όριο {value}{unit}",
  "alerts.temperatureLessThan": "Θερμοκρασία μικρότερη από",
  "alerts.temperatureLessThanThreshold": "Θερμοκρασία μικρότερη από το όριο {value}{unit}",
  "alerts.thresholdOutOfRange": "Πρέπει να είναι μεταξύ {min} και {max}",
  "alerts.thswGreaterThan": "THSW μεγαλύτερος από",
  "alerts.thswGreaterThanThreshold": "THSW μεγαλύτερος από το όριο {value}{unit}",
  "alerts.thswLessThan": "THSW μικρότερος από",
  "alerts.thswLessThanThreshold": "THSW μικρότερος από το όριο {value}{unit}",
  "alerts.thwGreaterThan": "THW μεγαλύτερος από",
  "alerts.thwGreaterThanThreshold": "THW μεγαλύτερος από το όριο {value}{unit}",
  "alerts.thwLessThan": "THW μικρότερος από",
  "alerts.thwLessThanThreshold": "THW μικρότερος από το όριο {value}{unit}",
  "alerts.triggerHistory": "Ιστορικό ειδοποίησης",
  "alerts.uvGreaterThan": "Δείκτης UV μεγαλύτερος από",
  "alerts.uvGreaterThanThreshold": "Δείκτης UV μεγαλύτερος από το όριο {value}{unit}",
  "alerts.uvLessThan": "Δείκτης UV μικρότερος από",
  "alerts.uvLessThanThreshold": "Δείκτης UV μικρότερος από το όριο {value}{unit}",
  "alerts.visibilityGreaterThanThreshold": "Ορατότητα μεγαλύτερη από το όριο {value}{unit}",
  "alerts.visibilityLessThanThreshold": "Ορατότητα μικρότερη από το όριο {value}{unit}",
  "alerts.visiblityGreaterThan": "Ορατότητα μεγαλύτερη από",
  "alerts.visiblityLessThan": "Ορατότητα μικρότερη από",
  "alerts.whichMeasure": "Για ποια μέτρηση θα θέλατε να ειδοποιηθείτε;",
  "alerts.whichModule": "Για ποια μονάδα θα θέλατε να ειδοποιηθείτε;",
  "alerts.whichSensor": "Για ποιον αισθητήρα θα θέλατε να ειδοποιηθείτε;",
  "alerts.windChillGreaterThan": "Ψυχρότητα ανέμου μεγαλύτερη από",
  "alerts.windChillGreaterThanThreshold": "Ψυχρότητα ανέμου μεγαλύτερη από το όριο {value}{unit}",
  "alerts.windChillLessThan": "Ψυχρότητα ανέμου μικρότερη από",
  "alerts.windChillLessThanThreshold": "Ψυχρότητα ανέμου μικρότερη από το όριο {value}{unit}",
  "alerts.windSpeedGreaterThan": "Ταχύτητα ανέμου μεγαλύτερη από",
  "alerts.windSpeedGreaterThanThreshold": "Ταχύτητα ανέμου μεγαλύτερη από το όριο {value}{unit}",
  "alerts.windSpeedLessThan": "Ταχύτητα ανέμου μικρότερη από",
  "alerts.windSpeedLessThanThreshold": "Ταχύτητα ανέμου μικρότερη από το όριο {value}{unit}",
  "appUpdate.updateAvailable": "Διαθέσιμη ενημέρωση",
  "appUpdate.updateAvailableOpenAppStore": "Πατήστε για να ανοίξετε το App Store",
  "appUpdate.updateAvailableOpenGooglePlay": "Πατήστε για να ανοίξετε το Google Play",
  "appUpdate.updateAvailableVersion": "Διαθέσιμη ενημέρωση: v{version}",
  "appUpdate.upgradeRequiredAndroid": "Απαιτείται αναβάθμιση της εφαρμογής σας. Επισκεφθείτε το Google Play για να αναβαθμίσετε.",
  "appUpdate.upgradeRequiredIos": "Απαιτείται αναβάθμιση της εφαρμογής σας. Επισκεφθείτε το App Store για να αναβαθμίσετε.",
  "astral.aboveHorizonAllDay": "Πάνω από τον ορίζοντα όλη την ημέρα",
  "astral.aboveTheHorizon": "πάνω από τον ορίζοντα",
  "astral.apparentSize": "Γωνιακό μέγεθος",
  "astral.apparentSizeAcross": "διάμετρος {size}",
  "astral.astronomicalDawn": "Αστρονομικό λυκαυγές",
  "astral.astronomicalDusk": "Αστρονομικό λυκόφως",
  "astral.belowHorizonAllDay": "Κάτω από τον ορίζοντα όλη την ημέρα",
  "astral.belowHorizonSince": "Κάτω από τον ορίζοντα από τις {time}",
  "astral.belowHorizonSinceOn": "Κάτω από τον ορίζοντα από {day} {time}",
  "astral.brightAllNight": "Φωτεινός ουρανός όλη τη νύχτα — ποτέ εντελώς σκοτεινά",
  "astral.brightestMoment": "Φωτεινότερη στιγμή",
  "astral.civilDawn": "Πολιτικό λυκαυγές",
  "astral.civilDusk": "Πολιτικό λυκόφως",
  "astral.darkSkyBetween": "Σκοτεινός ουρανός {from} → {to}",
  "astral.darkSkyWindow": "Σκοτεινός ουρανός {from} → {to} · {duration} χωρίς Σελήνη",
  "astral.dayLength": "Διάρκεια ημέρας",
  "astral.daylightThroughTheYear": "Διάρκεια ημέρας στη διάρκεια του έτους",
  "astral.dayOfCycle": "ημέρα {day} από {total}",
  "astral.doesNotOccurToday": "Δεν συμβαίνει σήμερα",
  "astral.domeHint": "Σύρετε για να διατρέξετε τη νύχτα",
  "astral.domeReadout": "{time} · {altitude} · {direction}",
  "astral.earliestSunrise": "Νωρίτερη ανατολή",
  "astral.earliestSunset": "Νωρίτερη δύση",
  "astral.equinox": "Ισημερία",
  "astral.equinoxIn": "Ισημερία σε {days, plural, one {# ημέρα} other {# ημέρες}}",
  "astral.evening": "Βράδυ",
  "astral.exactPhaseAt": "Ακριβώς στις {time}",
  "astral.firstQuarter": "Πρώτο τέταρτο",
  "astral.firstSunriseIn": "Πρώτη ανατολή σε {days, plural, one {# ημέρα} other {# ημέρες}}",
  "astral.firstSunsetIn": "Πρώτη δύση σε {days, plural, one {# ημέρα} other {# ημέρες}}",
  "astral.fullMoon": "Πανσέληνος",
  "astral.goldenHourBegins": "Έναρξη χρυσής ώρας",
  "astral.goldenHourEnds": "Λήξη χρυσής ώρας",
  "astral.highestPoint": "Υψηλότερο σημείο",
  "astral.inDays": "σε {days, plural, one {# ημέρα} other {# ημέρες}}",
  "astral.lastQuarter": "Τελευταίο τέταρτο",
  "astral.latestSunrise": "Αργότερη ανατολή",
  "astral.latestSunset": "Αργότερη δύση",
  "astral.litShort": "Φωτισμ.",
  "astral.longestDay": "Μεγαλύτερη ημέρα",
  "astral.lowestPoint": "Χαμηλότερο σημείο",
  "astral.maxAltitudeShort": "Μέγ.",
  "astral.midday": "Μεσημέρι",
  "astral.midnightSun": "Ήλιος του μεσονυκτίου",
  "astral.midnightSunPeriod": "Ήλιος του μεσονυκτίου",
  "astral.milestoneFootnotePolar": "Εδώ ο ήλιος ούτε ανατέλλει ούτε δύει για {days, plural, one {# ημέρα} other {# ημέρες}} τον χρόνο, οπότε αντί για τα συνηθισμένα άκρα ανατολής και δύσης η λίστα δείχνει πότε συμβαίνει αυτό.",
  "astral.milestoneFootnoteTemperate": "Η νωρίτερη δύση και η αργότερη ανατολή δεν συμπίπτουν με τη μικρότερη μέρα — τις δύο αυτές ημερομηνίες τις ορίζει η εξίσωση του χρόνου, όχι το ηλιοστάσιο.",
  "astral.moon": "Σελήνη",
  "astral.moonAltitude": "Ύψος",
  "astral.moonDirection": "Αζιμούθιο",
  "astral.moonDistance": "Απόσταση",
  "astral.moonlessFor": "{duration} χωρίς Σελήνη",
  "astral.moonPhases": "Φάσεις Σελήνης",
  "astral.moonrise": "Ανατολή Σελήνης",
  "astral.moonset": "Δύση Σελήνης",
  "astral.moonUpAllNight": "Η Σελήνη είναι πάνω από τον ορίζοντα όλη τη νύχτα",
  "astral.moonWashesOutNight": "Η Σελήνη είναι πάνω από τον ορίζοντα από τις {rise} έως τις {set} και φωτίζει όλη τη νύχτα",
  "astral.morning": "Πρωί",
  "astral.nauticalDawn": "Ναυτικό λυκαυγές",
  "astral.nauticalDusk": "Ναυτικό λυκόφως",
  "astral.newMoon": "Νέα Σελήνη",
  "astral.nextDay": "+1 ημ.",
  "astral.nextProperlyDarkNight": "Επόμενη πραγματικά σκοτεινή νύχτα",
  "astral.nextRise": "επόμενη ανατολή στις {time}",
  "astral.nextRiseOn": "επόμενη ανατολή {day} στις {time}",
  "astral.nextSevenNights": "Οι επόμενες επτά νύχτες",
  "astral.noAstronomicalDarknessTonight": "Χωρίς αστρονομικό σκοτάδι απόψε",
  "astral.noDarkNightAhead": "Καμία τις επόμενες δύο εβδομάδες",
  "astral.noSunriseToday": "Σήμερα ο Ήλιος δεν ανατέλλει",
  "astral.nowAtBearing": "τώρα {altitude} · αζιμούθιο {direction}",
  "astral.observing": "Παρατήρηση",
  "astral.ofDaylightLeft": "φως ημέρας απομένει",
  "astral.overTheNextThreeWeeks": "τις επόμενες 3 εβδομάδες",
  "astral.percentLit": "{percent} φωτισμένη",
  "astral.polarNight": "Πολική νύχτα",
  "astral.polarNightPeriod": "Πολική νύχτα",
  "astral.rightNow": "Τώρα",
  "astral.riseShort": "Ανατολή",
  "astral.setShort": "Δύση",
  "astral.shortestDay": "Μικρότερη ημέρα",
  "astral.solarNoon": "Ηλιακό μεσημέρι",
  "astral.solstice": "Ηλιοστάσιο",
  "astral.sunBelowHorizon": "Ήλιος {degrees}° κάτω από τον ορίζοντα",
  "astral.sunEvents": "Ηλιακά συμβάντα",
  "astral.sunNeverDarkEnough": "Ο Ήλιος δεν πέφτει ποτέ 18° κάτω από τον ορίζοντα",
  "astral.sunNeverSets": "Ο Ήλιος δεν δύει",
  "astral.sunrise": "Ανατολή Ηλίου",
  "astral.sunriseAndSunset": "Ανατολή και δύση Ηλίου",
  "astral.sunriseAt": "Ανατολή στις {time}",
  "astral.sunset": "Δύση Ηλίου",
  "astral.sunsetAt": "Δύση στις {time}",
  "astral.thisYearAtNorth": "Φέτος στο πλάτος {degrees}° Β",
  "astral.thisYearAtSouth": "Φέτος στο πλάτος {degrees}° Ν",
  "astral.tonight": "Απόψε",
  "astral.twilightAllNight": "Λυκόφως όλη τη νύχτα — ποτέ εντελώς σκοτεινά",
  "astral.upFor": "{duration} πάνω από τον ορίζοντα",
  "astral.usableLight": "Αξιοποιήσιμο φως",
  "astral.vsAverage": "{percent} από τον μέσο όρο",
  "astral.vsYesterday": "σε σχέση με χθες",
  "astral.waningCrescent": "Μειούμενη ημισέληνος",
  "astral.waningGibbous": "Μειούμενη κυρτή Σελήνη",
  "astral.waxingCrescent": "Αυξανόμενη ημισέληνος",
  "astral.waxingGibbous": "Αυξανόμενη κυρτή Σελήνη",
  "astral.whereToLook": "Πού να κοιτάξετε",
  "astral.withoutTheMoon": "{duration} χωρίς Σελήνη",
  "auth.alreadyHaveAccount": "Έχετε ήδη λογαριασμό;",
  "auth.authContainerTagline": "Ο προσωπικός σας πίνακας καιρού. Συνδέστε τους σταθμούς σας και αποκτήστε δεδομένα σε πραγματικό χρόνο στα χέρια σας.",
  "auth.backToLogin": "Επιστροφή στη σύνδεση",
  "auth.checkYourEmail": "Ελέγξτε το email σας",
  "auth.continueWithApple": "Συνέχεια με Apple",
  "auth.continueWithFacebook": "Συνέχεια με Facebook",
  "auth.continueWithGoogle": "Συνέχεια με Google",
  "auth.email": "Διεύθυνση email",
  "auth.emailRequiredLoginFacebook": "Απαιτείται άδεια πρόσβασης στη διεύθυνση email.",
  "auth.emailVerification": "Επαλήθευση email",
  "auth.emailVerificationFailure": "Παρουσιάστηκε πρόβλημα με την επαλήθευση του email σας",
  "auth.emailVerificationSuccess": "Το email σας επαληθεύτηκε επιτυχώς",
  "auth.firstName": "Όνομα",
  "auth.forgotPassword": "Ξεχάσατε τον κωδικό πρόσβασής σας;",
  "auth.forgotPasswordSubtitle": "Εισάγετε το email σας και θα σας στείλουμε έναν σύνδεσμο για επαναφορά του κωδικού σας.",
  "auth.lastName": "Επώνυμο",
  "auth.login": "Σύνδεση",
  "auth.loginSubtitle": "Καλώς ήρθατε πάλι! Παρακαλώ εισάγετε τα στοιχεία σας.",
  "auth.loginToSmartMixinDescription": "Συνδεθείτε στο SmartMixin για να αποκτήσετε πρόσβαση στους μετεωρολογικούς σταθμούς σας, να δείτε αναλύσεις και να διαχειριστείτε τον προσωπικό σας πίνακα καιρού.",
  "auth.logout": "Αποσύνδεση",
  "auth.logoutConfirmation": "Θέλετε να αποσυνδεθείτε;",
  "auth.noAccountYet": "Δεν έχετε ακόμη λογαριασμό;",
  "auth.or": "ή",
  "auth.password": "Κωδικός",
  "auth.passwordReset": "Επαναφορά κωδικού πρόσβασης",
  "auth.passwordResetSuccess": "Ο κωδικός πρόσβασής σας ενημερώθηκε επιτυχώς.",
  "auth.register": "Δημιουργία λογαριασμού",
  "auth.registerDescription": "Δημιουργήστε έναν δωρεάν λογαριασμό SmartMixin για να συνδέσετε τους μετεωρολογικούς σταθμούς σας, να παρακολουθείτε δεδομένα καιρού και να αποκτήσετε πρόσβαση σε ισχυρά εργαλεία ανάλυσης.",
  "auth.registerSubtitle": "Δημιουργήστε τον λογαριασμό σας για να ξεκινήσετε.",
  "auth.restorePassword": "Επαναφορά κωδικού πρόσβασης",
  "auth.restorePasswordSuccess": "Μόλις σας στείλαμε έναν σύνδεσμο επαναφοράς κωδικού πρόσβασης στη διεύθυνση {emailAddress} με περαιτέρω οδηγίες.",
  "auth.sendReset": "Αποστολή οδηγιών επαναφοράς",
  "auth.signInWithApple": "Σύνδεση με Apple",
  "auth.socialAccount": "ή χρησιμοποιήστε το λογαριασμό σας",
  "auth.staffVerificationCode": "Κωδικός επαλήθευσης",
  "auth.staffVerificationExpiresIn": "Επαληθεύτηκε. Λήγει σε {duration}.",
  "auth.staffVerificationInvalidCode": "Λανθασμένος κωδικός. Δοκιμάστε ξανά.",
  "auth.staffVerificationLoginAsStopped": "Το Login As διακόπηκε: εισαγάγετε κωδικό επαλήθευσης στην οθόνη Debug για να συνεχίσετε.",
  "auth.staffVerificationNotEnrolled": "Δεν έχει ρυθμιστεί εφαρμογή ελέγχου ταυτότητας για τον λογαριασμό σας. Προσθέστε μία από τις ρυθμίσεις ασφαλείας του back office.",
  "auth.staffVerificationPrompt": "Εισαγάγετε τον 6ψήφιο κωδικό από την εφαρμογή ελέγχου ταυτότητας ή έναν κωδικό ανάκτησης για να χρησιμοποιήσετε το Login As και την αναζήτηση χρηστών.",
  "auth.staffVerificationSetupLink": "Προσθήκη εφαρμογής ελέγχου ταυτότητας",
  "auth.staffVerificationSubmit": "Επαλήθευση",
  "auth.staffVerificationTitle": "Επαλήθευση προσωπικού",
  "calendar.afternoon": "Απόγευμα",
  "calendar.april": "Απρίλιος",
  "calendar.august": "Αύγουστος",
  "calendar.changePeriod": "Περίοδος: {period}. Αλλαγή περιόδου",
  "calendar.currentDay": "Τρέχουσα ημέρα",
  "calendar.dateFormat": "Μορφή ημερομηνίας",
  "calendar.day": "Ημέρα",
  "calendar.december": "Δεκέμβριος",
  "calendar.durationHours": "{hours} ώ.",
  "calendar.durationHoursMinutes": "{hours} ώ. {minutes} λ.",
  "calendar.durationMinutes": "{minutes} λ.",
  "calendar.durationMinutesSeconds": "{minutes} λ. {seconds} δ.",
  "calendar.durationSeconds": "{seconds} δ.",
  "calendar.end": "Λήξη",
  "calendar.endTime": "Ώρα λήξης",
  "calendar.evening": "Βράδυ",
  "calendar.february": "Φεβρουάριος",
  "calendar.goToNextDay": "Επόμενη ημέρα",
  "calendar.goToNextMonth": "Επόμενος μήνας",
  "calendar.goToNextWeek": "Επόμενη εβδομάδα",
  "calendar.goToNextYear": "Επόμενο έτος",
  "calendar.goToPreviousDay": "Προηγούμενη ημέρα",
  "calendar.goToPreviousMonth": "Προηγούμενος μήνας",
  "calendar.goToPreviousWeek": "Προηγούμενη εβδομάδα",
  "calendar.goToPreviousYear": "Προηγούμενο έτος",
  "calendar.hour": "Ώρα",
  "calendar.hoursCount": "{count, plural, one {# ώρα} other {# ώρες}}",
  "calendar.hoursShort": "ώ.",
  "calendar.hoursShortCount": "{count, plural, one {# ώ.} other {# ώ.}}",
  "calendar.january": "Ιανουάριος",
  "calendar.july": "Ιούλιος",
  "calendar.june": "Ιούνιος",
  "calendar.last12Hours": "Τελευταίες 12 ώρες",
  "calendar.last24Hours": "Τελευταίες 24 ώρες",
  "calendar.last30Days": "Τελευταίες 30 ημέρες",
  "calendar.last3Hours": "Τελευταίες 3 ώρες",
  "calendar.last6Hours": "Τελευταίες 6 ώρες",
  "calendar.last7Days": "Τελευταίες 7 ημέρες",
  "calendar.lastHour": "Τελευταία ώρα",
  "calendar.march": "Μάρτιος",
  "calendar.max": "Μέγιστη",
  "calendar.may": "Μάιος",
  "calendar.month": "Μήνας",
  "calendar.monthTotal": "Σύνολο μήνα",
  "calendar.morning": "Πρωί",
  "calendar.nextHours": "Οι επόμενες ώρες",
  "calendar.night": "Νύχτα",
  "calendar.november": "Νοέμβριος",
  "calendar.october": "Οκτώβριος",
  "calendar.oneDay": "1 ημέρα",
  "calendar.oneHour": "1 ώρα",
  "calendar.oneMonth": "1 μήνας",
  "calendar.oneWeek": "1 εβδομάδα",
  "calendar.periodRangeSpoken": "{start} έως {end}",
  "calendar.previous24Hours": "Προηγούμενες 24 ώρες",
  "calendar.previous30Days": "Προηγούμενες 30 ημέρες",
  "calendar.previous7Days": "Προηγούμενες 7 ημέρες",
  "calendar.previousDay": "Προηγούμενη μέρα",
  "calendar.previousHours": "Προηγούμενες ώρες",
  "calendar.previousMonth": "Προηγούμενος μήνας",
  "calendar.previousWeek": "Προηγούμενη εβδομάδα",
  "calendar.previousYear": "Προηγούμενο έτος",
  "calendar.sameDayLastYear": "Την ίδια ημέρα πέρυσι",
  "calendar.sameMonthLastYear": "Τον ίδιο μήνα πέρυσι",
  "calendar.selectADate": "Επιλέξτε μια ημερομηνία",
  "calendar.selectAggregation": "Επιλέξτε εμφανιζόμενη τιμή",
  "calendar.selectAMonth": "Επιλέξτε ένα μήνα",
  "calendar.selectAYear": "Επιλέξτε ένα χρόνο",
  "calendar.selectGranularity": "Επιλέξτε ανάλυση",
  "calendar.selectPeriod": "Επιλέξτε μια περίοδο",
  "calendar.september": "Σεπτέμβριος",
  "calendar.sixHours": "6 ώρες",
  "calendar.start": "Έναρξη",
  "calendar.startTime": "Ώρα έναρξης",
  "calendar.thirtyMinutes": "30 λεπτά",
  "calendar.threeHours": "3 ώρες",
  "calendar.timezone": "Ζώνη ώρας",
  "calendar.today": "Σήμερα",
  "calendar.untilChanged": "Μέχρι να αλλάξει",
  "calendar.untilTime": "Μέχρι {time}",
  "calendar.untilTodayAt": "Μέχρι σήμερα στις {time}",
  "calendar.untilTomorrowAt": "Μέχρι αύριο στις {time}",
  "calendar.use24HourFormat": "Χρήση 24ωρης ώρας",
  "calendar.week": "Εβδομάδα",
  "calendar.year": "Έτος",
  "calendar.yearToDate": "Από την αρχή του έτους",
  "calendar.yesterday": "Χθες",
  "charts.averageOverThePeriod": "Μέσος όρος κατά την περίοδο",
  "charts.calendarView": "Εμφάνιση ημερολογίου",
  "charts.charts": "Διαγράμματα",
  "charts.chartView": "Προβολή διαγράμματος",
  "charts.comparison": "Σύγκριση",
  "charts.customizeComparisonMetrics": "Προσαρμογή μετρικών σύγκρισης",
  "charts.customizeComparisonMetricsDescription": "Σύρετε τα στοιχεία για αναδιάταξη των μετρικών σύγκρισης. Πατήστε το εικονίδιο ματιού για εμφάνιση ή απόκρυψη μετρικών.",
  "charts.maxOverThePeriod": "Μέγιστο κατά την περίοδο",
  "charts.measureToDisplay": "Μέτρηση προς εμφάνιση",
  "charts.minMaxRange": "Ελάχ. / Μέγ.",
  "charts.noDataForThisPeriod": "Δεν υπάρχουν στοιχεία για αυτή την περίοδο",
  "charts.observations": "Παρατηρήσεις",
  "charts.observedTemperature": "Μετρημένη θερμοκρασία",
  "charts.showComparison": "Εμφάνιση σύγκρισης",
  "charts.stationComparison": "Σύγκριση σταθμών",
  "charts.stationComparisonDescription": "Σύγκριση ιστορικών δεδομένων καιρού με άλλο σταθμό",
  "charts.sumOverThePeriod": "Σύνολο κατά τη διάρκεια της περιόδου",
  "charts.viewAsList": "Λίστα",
  "charts.viewAsPeriods": "Περίοδοι",
  "common.add": "Προσθήκη",
  "common.altitude": "Υψόμετρο",
  "common.analysis": "Ανάλυση",
  "common.average": "Μέσος όρος",
  "common.back": "Πίσω",
  "common.backToHome": "Επιστροφή στην Αρχική",
  "common.cancel": "Ακύρωση",
  "common.cannotBeEmpty": "Αυτό το πεδίο δεν μπορεί να είναι κενό.",
  "common.close": "Κλείσιμο",
  "common.dailyForecast": "Ημερήσια πρόγνωση",
  "common.default": "Προεπιλογή",
  "common.delete": "Διαγραφή",
  "common.details": "Λεπτομέρειες",
  "common.edit": "Επεξεργασία",
  "common.exitFullscreen": "Έξοδος από πλήρη οθόνη",
  "common.forecast": "Πρόγνωση",
  "common.frequency": "Συχνότητα",
  "common.full": "Πλήρης",
  "common.fullscreen": "Πλήρης οθόνη",
  "common.help": "Βοήθεια",
  "common.hidden": "Κρυφά",
  "common.high": "Υψηλή",
  "common.iDontKnowYet": "Δεν ξέρω ακόμα",
  "common.indoor": "Εσωτερικός χώρος",
  "common.labelValue": "{label}: {value}",
  "common.lastUpdate": "Τελευταία ενημέρωση",
  "common.low": "Χαμηλή",
  "common.maximum": "Μέγιστο",
  "common.medium": "Μεσαία",
  "common.minimum": "Ελάχιστο",
  "common.more": "Περισσότερα",
  "common.moreInformation": "Περισσότερες πληροφορίες",
  "common.next": "Επόμενο",
  "common.no": "Όχι",
  "common.noAccountNeeded": "Δεν απαιτείται λογαριασμός",
  "common.noItemsAvailable": "Δεν υπάρχουν διαθέσιμα στοιχεία",
  "common.notNow": "Όχι τώρα",
  "common.now": "Τώρα",
  "common.numberOfActiveWarnings": "{warning_count, plural, one {# ενεργή προειδοποίηση καιρού} other {# ενεργές προειδοποιήσεις καιρού}}",
  "common.openSettings": "Ανοίξτε τις ρυθμίσεις",
  "common.outdoor": "Εξωτερικός χώρος",
  "common.pageNotFound": "Η σελίδα δεν βρέθηκε",
  "common.pageNotFoundDescription": "Η σελίδα που αναζητάτε δεν υπάρχει ή έχει μετακινηθεί.",
  "common.rain": "Βροχή",
  "common.share": "Κοινοποίηση",
  "common.shareImageFailed": "Δεν ήταν δυνατή η κοινοποίηση της εικόνας",
  "common.shareYourWeather": "Κοινοποιήστε τον καιρό σας",
  "common.skip": "Παράλειψη",
  "common.start": "Ξεκινήστε",
  "common.unknown": "Άγνωστο",
  "common.validate": "Επιβεβαίωση",
  "common.validEmail": "Απαιτείται έγκυρη διεύθυνση email.",
  "common.very_low": "Πολύ χαμηλή",
  "common.weatherObservations": "Παρατηρήσεις καιρού",
  "common.welcome": "Καλώς ήρθατε στο SmartMixin!",
  "common.wind": "Άνεμος",
  "common.yes": "Ναι",
  "common.zoomImage": "Μεγέθυνση εικόνας",
  "compass.E": "Α",
  "compass.E_long": "Ανατολικά",
  "compass.ENE": "ΑΒΑ",
  "compass.ENE_long": "Ανατολικά-βορειοανατολικά",
  "compass.ESE": "ΑΝΑ",
  "compass.ESE_long": "Ανατολικά-νοτιοανατολικά",
  "compass.N": "Β",
  "compass.N_long": "Βόρεια",
  "compass.NE": "ΒΑ",
  "compass.NE_long": "Βορειοανατολικά",
  "compass.NNE": "ΒΒΑ",
  "compass.NNE_long": "Βόρεια-βορειοανατολικά",
  "compass.NNW": "ΒΒΔ",
  "compass.NNW_long": "Βόρεια-βορειοδυτικά",
  "compass.NW": "ΒΔ",
  "compass.NW_long": "Βορειοδυτικά",
  "compass.S": "Ν",
  "compass.S_long": "Νότια",
  "compass.SE": "ΝΑ",
  "compass.SE_long": "Νοτιοανατολικά",
  "compass.SSE": "ΝΝΑ",
  "compass.SSE_long": "Νότια-νοτιοανατολικά",
  "compass.SSW": "ΝΝΔ",
  "compass.SSW_long": "Νότια-νοτιοδυτικά",
  "compass.SW": "ΝΔ",
  "compass.SW_long": "Νοτιοδυτικά",
  "compass.W": "Δ",
  "compass.W_long": "Δυτικά",
  "compass.WNW": "ΔΒΔ",
  "compass.WNW_long": "Δυτικά-βορειοδυτικά",
  "compass.WSW": "ΔΝΔ",
  "compass.WSW_long": "Δυτικά-νοτιοδυτικά",
  "dashboard.currentObservations": "Τρέχουσες παρατηρήσεις",
  "dashboard.currentRainEvent": "Τρέχουσα εκδήλωση βροχής",
  "dashboard.currentWeatherConditions": "Τρέχων καιρός",
  "dashboard.customizeDashboard": "Προσαρμογή",
  "dashboard.customizeDashboardDescription": "Σύρετε τα στοιχεία για αναδιάταξη του πίνακα ελέγχου. Πατήστε το εικονίδιο ματιού για εμφάνιση ή απόκρυψη ενοτήτων.",
  "dashboard.dashboard": "Επισκόπηση",
  "dashboard.dayRangeExpected": "{value} αναμένεται στις {time}",
  "dashboard.dayRangeReached": "{value} στις {time}",
  "dashboard.dayRangeSteady": "Σταθερά {value} όλη την ημέρα",
  "dashboard.hiddenSensors": "Κρυμμένοι αισθητήρες",
  "dashboard.lastRainEvent": "Τελευταία εκδήλωση βροχής",
  "dashboard.manageSensors": "Διαχείριση αισθητήρων",
  "dashboard.manageSensorsDescription": "Σύρετε στοιχεία για αναδιάταξη αισθητήρων. Πατήστε το εικονίδιο ματιού για εμφάνιση ή απόκρυψη αισθητήρων. Πατήστε ένα όνομα για μετονομασία.",
  "dashboard.pressureSummary": "Περίληψη πίεσης",
  "dashboard.rainEvents": "Εκδηλώσεις βροχής",
  "dashboard.rainSummary": "Περίληψη βροχής",
  "dashboard.shareOutdoorMeasures": "Κοινοποιήστε τις μετρήσεις σας απο τους εξωτερικούς χώρους.",
  "dashboard.shareOutdoorMeasuresDescription": "Συμμετάσχετε στην κοινότητα του SmartMixin, κάνοντας ορατές τις μετρήσεις σας από εξωτερικούς χώρους σε άλλους χρήστες. Η μετρήσεις εσωτερικών χώρων δεν θα κοινοποιηθούν ποτέ.",
  "dashboard.temperatureSummary": "Περίληψη θερμοκρασίας",
  "dashboard.windSummary": "Περίληψη ανέμου",
  "devices.batteryLevel": "Στάθμη μπαταρίας",
  "devices.firmwareVersion": "Έκδοση firmware",
  "devices.moduleCount": "{count, plural, one {# μονάδα} other {# μονάδες}}",
  "devices.moduleType": "Τύπος μονάδας",
  "devices.noNetatmoWeatherStationYet": "Δεν έχετε ακόμη μετεωρολογικό σταθμό Netatmo",
  "devices.noOutdoorModule": "Δεν υπάρχει λειτουργική εξωτερική μονάδα για αυτό το σταθμό",
  "devices.notReachable": "Μη προσβάσιμη",
  "devices.serialNumber": "Σειριακός αριθμός",
  "devices.signalAverage": "Μέτριο",
  "devices.signalBad": "Ασθενές",
  "devices.signalGood": "Καλό",
  "devices.signalStrength": "Ισχύς σήματος",
  "devices.signalUnknown": "Άγνωστο",
  "devices.visitNetatmoWebsite": "Επισκεφθείτε τον ιστότοπο της Netatmo",
  "devices.wifiStrength": "Ισχύς Wi-Fi",
  "forecastMaps.addColor": "Προσθήκη χρώματος",
  "forecastMaps.addLayer": "Προσθήκη επιπέδου",
  "forecastMaps.autoPreview": "Αυτόματο",
  "forecastMaps.backToMaps": "Πίσω στους χάρτες",
  "forecastMaps.build": "Δημιουργία",
  "forecastMaps.buildCompleted": "Η δημιουργία ολοκληρώθηκε",
  "forecastMaps.builderMetaDescription": "Συνθέστε προσαρμοσμένους χάρτες πρόγνωσης από τα επίπεδα των μετεωρολογικών μοντέλων.",
  "forecastMaps.builderTitle": "Εργαλείο δημιουργίας χαρτών",
  "forecastMaps.buildFailed": "Η δημιουργία απέτυχε. Δοκιμάστε ξανά.",
  "forecastMaps.buildNotPossible": "Αυτός ο χάρτης δεν μπορεί να δημιουργηθεί ακόμη — δεν υπάρχουν διαθέσιμα δεδομένα πρόγνωσης.",
  "forecastMaps.buildProgress": "Απόδοση… {completed}/{total} βήματα",
  "forecastMaps.buildStarting": "Έναρξη δημιουργίας…",
  "forecastMaps.byModel": "Ανά μοντέλο",
  "forecastMaps.byZone": "Ανά ζώνη",
  "forecastMaps.colormap": "Χρωματική κλίμακα",
  "forecastMaps.colormapCustom": "Προσαρμοσμένα χρώματα",
  "forecastMaps.colormapGroupDomain": "Μετεωρολογικά πρότυπα",
  "forecastMaps.colormapGroupMatplotlib": "Επιστημονικά πρότυπα",
  "forecastMaps.colorScale": "Χρωματική κλίμακα",
  "forecastMaps.contourLevels": "Επίπεδα ισοϋψών",
  "forecastMaps.countryCanada": "Καναδάς",
  "forecastMaps.countryFrance": "Γαλλία",
  "forecastMaps.countryGermany": "Γερμανία",
  "forecastMaps.countryItaly": "Ιταλία",
  "forecastMaps.countryScandinavia": "Σκανδιναβία",
  "forecastMaps.countrySpain": "Ισπανία",
  "forecastMaps.countrySwitzerland": "Ελβετία",
  "forecastMaps.countryUnitedStates": "Ηνωμένες Πολιτείες",
  "forecastMaps.customColormapMinColors": "Μια προσαρμοσμένη χρωματική κλίμακα απαιτεί τουλάχιστον δύο χρώματα",
  "forecastMaps.customExtent": "Προσαρμοσμένη έκταση",
  "forecastMaps.displayName": "Εμφανιζόμενο όνομα",
  "forecastMaps.downscaling": "Συντελεστής αραίωσης ανεμοδεικτών",
  "forecastMaps.dpi": "DPI",
  "forecastMaps.drawArea": "Σχεδίαση περιοχής",
  "forecastMaps.east": "Ανατολή",
  "forecastMaps.extentDrawHint": "Σύρετε στον χάρτη για να σχεδιάσετε την περιοχή",
  "forecastMaps.extentInvalid": "Η δύση πρέπει να είναι μικρότερη από την ανατολή και ο νότος μικρότερος από τον βορρά",
  "forecastMaps.height": "Ύψος (ίντσες)",
  "forecastMaps.hourOffset": "+{hour} ώρ.",
  "forecastMaps.invalidHexColor": "Μη έγκυρο χρώμα — χρησιμοποιήστε #RRGGBB",
  "forecastMaps.layers": "Επίπεδα",
  "forecastMaps.layerTypeBarbs": "Ανεμοδείκτες",
  "forecastMaps.layerTypeContour": "Ισοϋψείς γραμμές",
  "forecastMaps.layerTypeFilledContour": "Γεμισμένες ισοϋψείς",
  "forecastMaps.layerTypeMagnitude": "Μέγεθος",
  "forecastMaps.layerTypeRaster": "Ράστερ",
  "forecastMaps.layerTypeVectorField": "Διανυσματικό πεδίο",
  "forecastMaps.leave": "Έξοδος",
  "forecastMaps.levelsCount": "Πλήθος",
  "forecastMaps.levelsInvalid": "Μη έγκυρα επίπεδα ισοϋψών",
  "forecastMaps.levelsModeArange": "Σταθερό βήμα",
  "forecastMaps.levelsModeExplicit": "Ρητές τιμές",
  "forecastMaps.levelsModeLinspace": "Ομοιόμορφη κατανομή (πλήθος)",
  "forecastMaps.levelsStep": "Βήμα",
  "forecastMaps.levelsValues": "Τιμές",
  "forecastMaps.levelsValuesHint": "Διαχωρισμένες με κόμματα, αύξουσες",
  "forecastMaps.localTimeHint": "Εμφανίζεται στην τοπική σας ώρα",
  "forecastMaps.mapDescription": "Περιγραφή",
  "forecastMaps.mapName": "Όνομα χάρτη",
  "forecastMaps.mapNameRequired": "Εισαγάγετε ένα όνομα",
  "forecastMaps.mapSettings": "Ρυθμίσεις χάρτη",
  "forecastMaps.mapView": "Διαδραστικός χάρτης",
  "forecastMaps.maxLayersReached": "Αυτός ο χάρτης έφτασε το μέγιστο των {max} επιπέδων.",
  "forecastMaps.maxValue": "Μέγιστη τιμή",
  "forecastMaps.memoryBudgetExceeded": "Η ανάλυση υπερβαίνει τον προϋπολογισμό απόδοσης — μειώστε το DPI ή το ύψος",
  "forecastMaps.memoryBudgetUsage": "Προϋπολογισμός απόδοσης: {percent}%",
  "forecastMaps.metaDescription": "Κινούμενοι χάρτες πρόγνωσης από τους υπολογισμούς των μετεωρολογικών μοντέλων.",
  "forecastMaps.metric": "Μέγεθος μέτρησης",
  "forecastMaps.metricRequired": "Επιλέξτε ένα μέγεθος",
  "forecastMaps.metricUnavailable": "Μη διαθέσιμο για αυτό το μοντέλο",
  "forecastMaps.minBelowMax": "Το ελάχιστο πρέπει να είναι μικρότερο από το μέγιστο",
  "forecastMaps.minMaxRequired": "Οι ελάχιστες και μέγιστες τιμές είναι υποχρεωτικές για αυτόν τον τύπο επιπέδου",
  "forecastMaps.minValue": "Ελάχιστη τιμή",
  "forecastMaps.modelNoRun": "Δεν υπάρχει ολοκληρωμένη εκτέλεση ακόμη",
  "forecastMaps.moveLayerDown": "Μετακίνηση κάτω",
  "forecastMaps.moveLayerUp": "Μετακίνηση πάνω",
  "forecastMaps.myMaps": "Οι χάρτες μου",
  "forecastMaps.nanClipToMin": "Περιορισμός στο ελάχιστο",
  "forecastMaps.nanMask": "Μάσκα",
  "forecastMaps.nanPolicy": "Ελλιπή δεδομένα",
  "forecastMaps.nanSkip": "Παράλειψη",
  "forecastMaps.noCompletedRun": "Αυτός ο χάρτης δεν έχει δημιουργηθεί ακόμη. Ελέγξτε ξανά σύντομα.",
  "forecastMaps.noLayers": "Δεν υπάρχουν επίπεδα ακόμη. Προσθέστε ένα επίπεδο για να ξεκινήσετε.",
  "forecastMaps.noMapsAvailable": "Δεν υπάρχουν ακόμη διαθέσιμοι χάρτες πρόγνωσης.",
  "forecastMaps.north": "Βορράς",
  "forecastMaps.opacity": "Αδιαφάνεια",
  "forecastMaps.overlayLegend": "Υπόμνημα",
  "forecastMaps.pause": "Παύση",
  "forecastMaps.play": "Αναπαραγωγή",
  "forecastMaps.pointValueError": "Δεν ήταν δυνατή η φόρτωση της πρόγνωσης για αυτό το σημείο.",
  "forecastMaps.pointValueLoading": "Φόρτωση πρόγνωσης…",
  "forecastMaps.pointValueUnavailable": "Δεν υπάρχουν δεδομένα για αυτήν την ώρα.",
  "forecastMaps.presets": "Πρότυπα",
  "forecastMaps.preview": "Προεπισκόπηση",
  "forecastMaps.previewEmptyHint": "Ρυθμίστε τουλάχιστον ένα έγκυρο επίπεδο για να αποδοθεί προεπισκόπηση.",
  "forecastMaps.previewFailed": "Η προεπισκόπηση απέτυχε",
  "forecastMaps.previewHour": "Ώρα πρόγνωσης",
  "forecastMaps.previewRendering": "Απόδοση προεπισκόπησης…",
  "forecastMaps.projection": "Προβολή",
  "forecastMaps.projectionLambertConformal": "Σύμμορφη Lambert",
  "forecastMaps.projectionMercator": "Μερκατορική",
  "forecastMaps.projectionPlateCarree": "Plate carrée",
  "forecastMaps.projectionStereographic": "Στερεογραφική",
  "forecastMaps.regionEurope": "Ευρώπη",
  "forecastMaps.regionNorthAmerica": "Βόρεια Αμερική",
  "forecastMaps.removeColor": "Αφαίρεση χρώματος",
  "forecastMaps.removeLayer": "Αφαίρεση επιπέδου",
  "forecastMaps.retry": "Δοκιμάστε ξανά",
  "forecastMaps.run": "Εκτέλεση: {run}",
  "forecastMaps.save": "Αποθήκευση",
  "forecastMaps.selectExtentOnMap": "Επιλογή περιοχής στον χάρτη",
  "forecastMaps.south": "Νότος",
  "forecastMaps.title": "Χάρτες πρόγνωσης",
  "forecastMaps.uMetric": "Συνιστώσα U",
  "forecastMaps.unitConversion": "Μετατροπή μονάδων",
  "forecastMaps.unitNone": "Καμία",
  "forecastMaps.unsavedChangesBody": "Έχετε μη αποθηκευμένες αλλαγές. Έξοδος και απόρριψή τους;",
  "forecastMaps.unsavedChangesTitle": "Μη αποθηκευμένες αλλαγές",
  "forecastMaps.useCurrentView": "Χρήση τρέχουσας προβολής",
  "forecastMaps.useModelDomain": "Ανενεργό: χρησιμοποιείται ολόκληρο το πεδίο του μοντέλου",
  "forecastMaps.utcTime": "UTC: {time}",
  "forecastMaps.uvMetricsDiffer": "Τα μεγέθη U και V πρέπει να διαφέρουν",
  "forecastMaps.valueBetween": "Πρέπει να είναι μεταξύ {min} και {max}",
  "forecastMaps.variable": "Μεταβλητή",
  "forecastMaps.viewMap": "Προβολή χάρτη",
  "forecastMaps.vMetric": "Συνιστώσα V",
  "forecastMaps.west": "Δύση",
  "forecastMaps.windAnimation": "Κίνηση ανέμου",
  "forecastModels.addForecastModel": "Προσθήκη μοντέλου",
  "forecastModels.atYourStations": "Διαθέσιμα στους σταθμούς σας",
  "forecastModels.coverageLoading": "Υπολογισμός των σταθμών που καλύπτει κάθε μοντέλο…",
  "forecastModels.description_AROME": "Το μοντέλο υψηλής ανάλυσης της Météo France που επιτρέπει την επίλυση της μεταφοράς, πάνω από τη Δυτική Ευρώπη με ανάλυση 1,3 χλμ. Το καλύτερο στην κατηγορία του για βραχυπρόθεσμες προβλέψεις στη Γαλλία· ανανεώνεται κάθε τρεις ώρες.",
  "forecastModels.description_ARPEGE_EU": "Το ευρωπαϊκό εμφωλευμένο πεδίο του μοντέλου ARPEGE της Météo France με ανάλυση 10 χλμ. Μεσοπρόθεσμες προβλέψεις πάνω από την Ευρώπη, ανανεώνονται τέσσερις φορές την ημέρα.",
  "forecastModels.description_ARPEGE_GLOBAL": "Το παγκόσμιο αριθμητικό μοντέλο πρόγνωσης καιρού της Météo France με ανάλυση 25 χλμ, που τρέχει έως περίπου 4 ημέρες. Ανανεώνεται τέσσερις φορές την ημέρα.",
  "forecastModels.description_DMI_DINI": "Το HARMONIE DINI της DMI: ένα μοντέλο που επιτρέπει την επίλυση της μεταφοράς, πάνω από τη βορειοδυτική Ευρώπη — Δανία, Μπενελούξ, Ιρλανδία, Ηνωμένο Βασίλειο και Σκανδιναβία — με ανάλυση 2 χλμ που φτάνει έως τις 60 ώρες, ανανεώνεται οκτώ φορές την ημέρα. Περιέχει τροποποιημένα ανοικτά δεδομένα της DMI (CC BY 4.0).",
  "forecastModels.description_EC_GDPS": "Το παγκόσμιο ντετερμινιστικό σύστημα πρόβλεψης της Environment Canada: ένα παγκόσμιο μεσοπρόθεσμο μοντέλο με ανάλυση 15 χλμ που τρέχει έως 10 ημέρες, ενημερώνεται δύο φορές την ημέρα.",
  "forecastModels.description_EC_HRDPS": "Το ντετερμινιστικό σύστημα πρόβλεψης υψηλής ανάλυσης της Environment Canada: ένα μοντέλο που επιτρέπει την επίλυση της μεταφοράς, πάνω από τον Καναδά και τις βόρειες Ηνωμένες Πολιτείες με ανάλυση 2,5 χλμ που φτάνει έως τις 48 ώρες, ανανεώνεται τέσσερις φορές την ημέρα.",
  "forecastModels.description_EC_RDPS": "Το περιφερειακό ντετερμινιστικό σύστημα πρόβλεψης της Environment Canada: ένα μεσοπρόθεσμο μοντέλο πάνω από τη Βόρεια Αμερική με ανάλυση 10 χλμ, ανανεώνεται τέσσερις φορές την ημέρα.",
  "forecastModels.description_ECMWF_HRES": "Το κορυφαίο μοντέλο υψηλής ανάλυσης (IFS) του Ευρωπαϊκού Κέντρου Μεσοπρόθεσμων Μετεωρολογικών Προγνώσεων, ευρέως αναγνωρισμένο ως το κορυφαίο παγκόσμιο σύστημα πρόγνωσης. Καλύπτει ολόκληρο τον πλανήτη με ανάλυση 25 χλμ. έως 15 ημέρες, με ενημέρωση τέσσερις φορές την ημέρα. Περιέχει τροποποιημένα ανοικτά δεδομένα του ECMWF (CC BY 4.0).",
  "forecastModels.description_GFS": "Το κορυφαίο παγκόσμιο μεσοπρόθεσμο μοντέλο της NOAA. Καλύπτει ολόκληρο τον πλανήτη με ανάλυση 25 χλμ έως 16 ημέρες, ενημερώνεται τέσσερις φορές την ημέρα.",
  "forecastModels.description_HRRR_CONUS": "Το High-Resolution Rapid Refresh της NOAA: ένα μοντέλο που επιτρέπει την επίλυση της μεταφοράς, πάνω από τις ηπειρωτικές ΗΠΑ με ανάλυση 3 χλμ, ανανεώνεται κάθε ώρα. Καταλληλότερο για πολύ βραχυπρόθεσμες προβλέψεις καταιγίδων και ακραίων καιρικών συνθηκών.",
  "forecastModels.description_ICON": "Το παγκόσμιο μοντέλο ICON της DWD με ανάλυση 13 km που καλύπτει ολόκληρο τον πλανήτη έως και 7,5 ημέρες, ενημερώνεται τέσσερις φορές την ημέρα. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_ICON_2I": "Το ICON-2I της ItaliaMeteo, που λειτουργεί από κοινού με την ARPAE: ένα μοντέλο που επιτρέπει την επίλυση της μεταφοράς, πάνω από την Ιταλία με ανάλυση 2,2 χλμ που φτάνει έως τις 72 ώρες, ανανεώνεται δύο φορές την ημέρα. Περιέχει ανοικτά δεδομένα της ItaliaMeteo (CC BY 4.0).",
  "forecastModels.description_ICON_CH1": "Η εκτέλεση ελέγχου του ICON-CH1-EPS της MeteoSwiss: ένα μοντέλο που επιτρέπει την επίλυση της μεταφοράς, πάνω από τις Άλπεις με ανάλυση 1 χλμ που φτάνει έως τις 33 ώρες, ανανεώνεται κάθε τρεις ώρες.",
  "forecastModels.description_ICON_CH2": "Η εκτέλεση ελέγχου του ICON-CH2-EPS της MeteoSwiss: ένα μοντέλο που επιτρέπει την επίλυση της μεταφοράς, πάνω από τις Άλπεις — Ελβετία και τη γύρω αλπική περιοχή — με ανάλυση 2,1 χλμ που φτάνει έως τις 120 ώρες, ανανεώνεται τέσσερις φορές την ημέρα.",
  "forecastModels.description_ICON_DE": "Το μοντέλο υψηλής ανάλυσης της DWD που επιτρέπει την επίλυση της μεταφοράς, πάνω από τη Γερμανία και τις γύρω χώρες με ανάλυση 2,2 χλμ. Βραχυπρόθεσμες προβλέψεις ανανεώνονται δύο φορές την ημέρα. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_ICON_EU": "Το ευρωπαϊκό εμφωλευμένο πεδίο του μοντέλου ICON της DWD με ανάλυση 7 χλμ που καλύπτει την Ευρώπη και τον Βόρειο Ατλαντικό. Μεσοπρόθεσμες προβλέψεις ανανεώνονται τέσσερις φορές την ημέρα. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_MET_NORWAY": "Η ανοιχτή υπηρεσία πρόγνωσης καιρού του Νορβηγικού Μετεωρολογικού Ινστιτούτου, που αναμιγνύει σκανδιναβικά μοντέλα υψηλής ανάλυσης με δεδομένα ECMWF για να παρέχει παγκόσμιες προβλέψεις έως 10 ημέρες μπροστά.",
  "forecastModels.description_MF_AROME_ANTILLES": "Εμφωλευμένο πεδίο AROME πάνω από τις γαλλικές Αντίλλες (Γουαδελούπη, Μαρτινίκα) με ανάλυση 2,5 χλμ. Βραχυπρόθεσμες προβλέψεις ανανεώνονται τέσσερις φορές την ημέρα.",
  "forecastModels.description_MF_AROME_GUYANE": "Εμφωλευμένο πεδίο AROME πάνω από τη Γαλλική Γουιάνα με ανάλυση 2,5 χλμ. Βραχυπρόθεσμες προβλέψεις ανανεώνονται τέσσερις φορές την ημέρα.",
  "forecastModels.description_MF_AROME_NOUVELLE_CALEDONIE": "Εμφωλευμένο πεδίο AROME πάνω από τη Νέα Καληδονία με ανάλυση 2,5 χλμ. Βραχυπρόθεσμες προβλέψεις ανανεώνονται τέσσερις φορές την ημέρα.",
  "forecastModels.description_MF_AROME_POLYNESIE": "Εμφωλευμένο πεδίο AROME πάνω από τη Γαλλική Πολυνησία με ανάλυση 2,5 χλμ. Βραχυπρόθεσμες προβλέψεις ανανεώνονται τέσσερις φορές την ημέρα.",
  "forecastModels.description_MF_AROME_REUNION_MAYOTTE": "Εμφωλευμένο πεδίο AROME πάνω από τη Ρεϋνιόν και τη Μαγιότ με ανάλυση 2,5 χλμ. Βραχυπρόθεσμες προβλέψεις ανανεώνονται τέσσερις φορές την ημέρα.",
  "forecastModels.description_RRFS_CONUS": "Το σύστημα Rapid Refresh Forecast της NOAA πάνω από τις ηπειρωτικές ΗΠΑ με ανάλυση 3 km. Ωριαίες προγνώσεις που ανανεώνονται οκτώ φορές την ημέρα, έως 84 ώρες στις τέσσερις κύριες εκτελέσεις και 18 ώρες στις υπόλοιπες.",
  "forecastModels.description_RRFS_NORTH_AMERICA": "Το σύστημα Rapid Refresh Forecast της NOAA που καλύπτει ολόκληρη τη Βόρεια Αμερική με ανάλυση 13 km. Ωριαίες προγνώσεις έως 84 ώρες, ανανεώνονται τέσσερις φορές την ημέρα.",
  "forecastModels.description_SMARTMIXIN_MULTIMODEL": "Η πρόγνωση-ναυαρχίδα του SmartMixin. Για κάθε ώρα στην τοποθεσία σας, επιλέγουμε το καλύτερο διαθέσιμο μοντέλο — συνήθως ένα περιφερειακό μοντέλο υψηλής ανάλυσης όπου υπάρχει (AROME στη Γαλλία, ICON-D2 στη Γερμανία, HRRR στις ΗΠΑ, ARPEGE Europe σε ολόκληρη την ήπειρο…) και επιστρέφουμε σε ένα παγκόσμιο μοντέλο αλλού — και έπειτα γεμίζουμε τυχόν κενά από γειτονικές πηγές. Το αποτέλεσμα είναι μια ενιαία, αδιάλειπτη πρόγνωση που καλύπτει οπουδήποτε στον κόσμο έως 14 ημέρες, ανανεώνεται αυτόματα όποτε ενημερώνεται κάποιο από τα υποκείμενα μοντέλα.",
  "forecastModels.description_WEATHERFLOW_FORECAST": "Η αποκλειστική παγκόσμια πρόγνωση της Weatherflow που αναμιγνύει πολλαπλά αριθμητικά μοντέλα καιρού με παρατηρήσεις από το δίκτυό της Tempest μετεωρολογικών σταθμών. 10ήμερος παγκόσμιος ορίζοντας.",
  "forecastModels.everywhereElse": "Παντού αλλού",
  "forecastModels.everywhereElseFoot": "Χρησιμοποιείται σε κάθε σταθμό που δεν καλύπτουν τα προτιμώμενα μοντέλα σας.",
  "forecastModels.everywhereElsePick": "Επιλέξτε ένα",
  "forecastModels.fallbackBlend": "Μείγμα SmartMixin",
  "forecastModels.fallbackBlendSub": "Συνδυάζει πολλά μοντέλα, το καθένα εκεί όπου είναι ισχυρότερο.",
  "forecastModels.fallbackEcmwf": "ECMWF",
  "forecastModels.fallbackEcmwfSub": "ECMWF HRES όπου φτάνει.",
  "forecastModels.fallbackGfs": "GFS",
  "forecastModels.fallbackGfsSub": "Το παγκόσμιο μοντέλο της NOAA. Αυτό που χρησιμοποιεί σήμερα κάθε λογαριασμός.",
  "forecastModels.fallbackResolution": "Υψηλότερη ανάλυση",
  "forecastModels.fallbackResolutionSub": "Το πυκνότερο πλέγμα που είναι διαθέσιμο σε κάθε σταθμό.",
  "forecastModels.forecastChipLabelWithRun": "{model}, εκτέλεση {run}",
  "forecastModels.forecastChipRunHint": "Πατήστε παρατεταμένα για εμφάνιση ή απόκρυψη της τελευταίας εκτέλεσης",
  "forecastModels.forecastComparisonDescription": "Εύκολη σύγκριση αποτελεσμάτων μοντέλων πρόγνωσης από διάφορες πηγές",
  "forecastModels.forecastFollowingPreferences": "Σύμφωνα με τις προτιμήσεις σας",
  "forecastModels.forecastModel": "Μοντέλο πρόγνωσης",
  "forecastModels.forecastModelComparison": "Σύγκριση μοντέλων πρόγνωσης",
  "forecastModels.forecastModelCoverage": "Κάλυψη",
  "forecastModels.forecastModelDescription": "Περιγραφή",
  "forecastModels.forecastModels": "Μοντέλα πρόγνωσης",
  "forecastModels.forecastModelScopeGlobal": "Παγκόσμιο",
  "forecastModels.forecastModelScopeGlobalDescription": "Αυτό το μοντέλο καλύπτει ολόκληρο τον πλανήτη.",
  "forecastModels.forecastModelScopeRegional": "Περιφερειακό",
  "forecastModels.forecastModelScopeRegionalDescription": "Αυτό το μοντέλο καλύπτει μόνο μια συγκεκριμένη περιοχή.",
  "forecastModels.forecastModelSpecifications": "Προδιαγραφές",
  "forecastModels.forecastNoPinLocation": "Κανένα προτιμώμενο μοντέλο δεν φτάνει σε αυτή την τοποθεσία — αποφασίζει το «παντού αλλού».",
  "forecastModels.forecastNoPinStation": "Κανένα προτιμώμενο μοντέλο δεν φτάνει σε αυτόν τον σταθμό — αποφασίζει το «παντού αλλού».",
  "forecastModels.forecastNoPreferredModels": "Δεν έχουν οριστεί ακόμη προτιμώμενα μοντέλα.",
  "forecastModels.forecastOverrideElsewhere": "Οι προτιμήσεις σας ισχύουν παντού αλλού.",
  "forecastModels.forecastPickForLocation": "Ή επιλέξτε ένα για αυτή την τοποθεσία",
  "forecastModels.forecastPickForStation": "Ή επιλέξτε ένα για αυτόν τον σταθμό",
  "forecastModels.forecastPinWinsLocation": "{model} — το πρώτο προτιμώμενο μοντέλο σας που φτάνει σε αυτή την τοποθεσία.",
  "forecastModels.forecastPinWinsStation": "{model} — το πρώτο προτιμώμενο μοντέλο σας που φτάνει σε αυτόν τον σταθμό.",
  "forecastModels.forecastServedNowHere": "Αυτή τη στιγμή εδώ είναι {model}",
  "forecastModels.forecastSetForLocation": "Ορίστηκε για αυτή την τοποθεσία",
  "forecastModels.forecastSetForStation": "Ορίστηκε για αυτόν τον σταθμό",
  "forecastModels.forecastSettingsRowSub": "Προτιμώμενα μοντέλα και τι ισχύει παντού αλλού",
  "forecastModels.forecastStopUsingHere": "Να μη χρησιμοποιείται εδώ",
  "forecastModels.forecastUseForLocation": "Χρήση {model} για αυτή την τοποθεσία",
  "forecastModels.forecastUseForStation": "Χρήση {model} για αυτόν τον σταθμό",
  "forecastModels.forecastUsePreferred": "Χρήση των προτιμώμενων μοντέλων μου",
  "forecastModels.frequencyHourly": "Κάθε ώρα",
  "forecastModels.horizon": "Ορίζοντας",
  "forecastModels.horizonValue": "μέχρι {value} ώρες",
  "forecastModels.meshSize": "Μέγεθος πλέγματος",
  "forecastModels.pickerShowAll": "Εμφάνιση όλου του καταλόγου",
  "forecastModels.pickerUnreachable": "{count, plural, one {# ακόμη μοντέλο δεν φτάνει} other {# ακόμη μοντέλα δεν φτάνουν}} σε κανέναν από τους σταθμούς σας",
  "forecastModels.pinInUse": "Σε χρήση",
  "forecastModels.pinShadowed": "Δεν χρησιμοποιείται ποτέ — ένα μοντέλο παραπάνω καλύπτει όλους τους σταθμούς σας",
  "forecastModels.pinSlots": "{used} από {max} · επιλέξτε μοντέλο",
  "forecastModels.pinSlotsFull": "{max, plural, one {Η μοναδική θέση είναι κατειλημμένη. Αφαιρέστε το μοντέλο της για να προσθέσετε άλλο.} other {Και οι # θέσεις είναι κατειλημμένες. Αφαιρέστε μία για να προσθέσετε άλλη.}}",
  "forecastModels.pinsUncoveredCount": "{used} από τους {count, plural, one {# σταθμό} other {# σταθμούς}} σας: κανένα προτιμώμενο μοντέλο δεν {used, plural, =1 {τον φτάνει} other {τους φτάνει}} — αποφασίζει το «παντού αλλού».",
  "forecastModels.pinsUncoveredNamed": "{stations}: κανένα προτιμώμενο μοντέλο δεν {count, plural, one {τον φτάνει} other {τους φτάνει}} — αποφασίζει το «παντού αλλού».",
  "forecastModels.pinUnreachable": "Δεν χρησιμοποιείται ποτέ — δεν φτάνει σε κανέναν από τους σταθμούς σας",
  "forecastModels.pinUsedAt": "Σε χρήση σε {stations}",
  "forecastModels.pinUsedAtAll": "{count, plural, one {Σε χρήση στον σταθμό σας} other {Σε χρήση και στους # σταθμούς}}",
  "forecastModels.pinUsedAtSome": "Σε χρήση σε {used} από {count, plural, one {# σταθμό} other {# σταθμούς}}",
  "forecastModels.preferredModels": "Προτιμώμενα μοντέλα",
  "forecastModels.preferredModelsAll": "Μία λίστα, όλοι οι σταθμοί",
  "forecastModels.preferredModelsOne": "Μία λίστα, ισχύει παντού",
  "forecastModels.publisher": "Εκδότης",
  "forecastModels.removePreferredModel": "Αφαίρεση του {model} από τα προτιμώμενα μοντέλα σας",
  "forecastModels.resetForecastPreference": "Επαναφορά",
  "forecastModels.resetForecastPreferenceHint": "Διαγράφει τα προτιμώμενα μοντέλα σας και επιστρέφει στην προεπιλογή του SmartMixin.",
  "forecastModels.servedNowMany": "Αυτή τη στιγμή: GFS {count, plural, one {στον σταθμό σας} other {και στους # σταθμούς}}.",
  "forecastModels.servedNowNone": "Αυτή τη στιγμή: GFS παντού.",
  "forecastModels.title_SMARTMIXIN_MULTIMODEL": "SmartMixin πολυμοντέλο",
  "forecastModels.title_WEATHERFLOW_FORECAST": "Πρόγνωση Weatherflow",
  "forecastModels.weatherForecastModels": "Μοντέλα πρόγνωσης καιρού",
  "helpCenter.articleCount": "{count, plural, one {# άρθρο} other {# άρθρα}}",
  "helpCenter.articleNotFound": "Το άρθρο δεν βρέθηκε",
  "helpCenter.articleNotFoundDescription": "Το άρθρο που αναζητάτε δεν υπάρχει.",
  "helpCenter.backToHelpCenter": "Επιστροφή στο Κέντρο Βοήθειας",
  "helpCenter.browseByCategory": "Περιήγηση ανά κατηγορία",
  "helpCenter.categoryNotFound": "Η κατηγορία δεν βρέθηκε",
  "helpCenter.categoryNotFoundDescription": "Αυτή η κατηγορία δεν υπάρχει ή δεν έχει άρθρα.",
  "helpCenter.contactSupport": "Επικοινωνία με την υποστήριξη",
  "helpCenter.feedbackHelpsImprove": "Η γνώμη σας μας βοηθά να βελτιώσουμε τα άρθρα βοήθειας.",
  "helpCenter.feedbackReasonNotAnswer": "Δεν απαντά στην ερώτησή μου",
  "helpCenter.feedbackReasonOutdated": "Οι πληροφορίες είναι παρωχημένες",
  "helpCenter.feedbackReasonUnclear": "Οι οδηγίες δεν είναι σαφείς",
  "helpCenter.feedbackWhatWentWrong": "Ποιο ήταν το πρόβλημα;",
  "helpCenter.helpCategoryAccount": "Λογαριασμός",
  "helpCenter.helpCategoryBilling": "Χρεώσεις",
  "helpCenter.helpCategoryForecast": "Προγνώσεις",
  "helpCenter.helpCategoryGettingStarted": "Ξεκινώντας",
  "helpCenter.helpCategoryProviders": "Πάροχοι",
  "helpCenter.helpCategoryStations": "Σταθμοί",
  "helpCenter.helpCategoryTroubleshooting": "Αντιμετώπιση προβλημάτων",
  "helpCenter.helpCenter": "Κέντρο βοήθειας",
  "helpCenter.landingDescription": "Βρείτε απαντήσεις σε συχνές ερωτήσεις και μάθετε πώς να αξιοποιήσετε στο έπακρο το SmartMixin.",
  "helpCenter.linkToSection": "Σύνδεσμος σε αυτήν την ενότητα",
  "helpCenter.menuItemDescription": "Συχνές ερωτήσεις και οδηγοί",
  "helpCenter.minRead": "{minutes} λεπ. ανάγνωσης",
  "helpCenter.onThisPage": "Σε αυτήν τη σελίδα",
  "helpCenter.platformMobileApp": "Εφαρμογή κινητού",
  "helpCenter.platformMobileOnly": "Μόνο στην εφαρμογή κινητού",
  "helpCenter.platformWebApp": "Εφαρμογή ιστού",
  "helpCenter.platformWebOnly": "Μόνο στην εφαρμογή ιστού",
  "helpCenter.popularArticles": "Δημοφιλή άρθρα",
  "helpCenter.relatedArticles": "Σχετικά άρθρα",
  "helpCenter.searchArticles": "Αναζήτηση άρθρων...",
  "helpCenter.stillNeedHelp": "Χρειάζεστε ακόμα βοήθεια;",
  "helpCenter.stillNeedHelpDescription": "Αν αυτό το άρθρο δεν απάντησε στην ερώτησή σας, θα χαρώ να σας βοηθήσω προσωπικά.",
  "helpCenter.supportEmailSubject": "Βοήθεια SmartMixin",
  "helpCenter.supportEmailSubjectTopic": "Βοήθεια SmartMixin — {topic}",
  "helpCenter.thankYouForFeedback": "Ευχαριστούμε για την ανατροφοδότησή σας!",
  "helpCenter.wasArticleHelpful": "Σας φάνηκε χρήσιμο αυτό το άρθρο;",
  "intro.locationDescription": "Ενεργοποίησε την πρόσβαση τοποθεσίας για ακριβείς προβλέψεις για την περιοχή σου — τέλος στις γενικές προβλέψεις.",
  "intro.locationTitle": "Προβλέψεις για εσένα",
  "intro.notificationDescription": "Ενεργοποίησε τις ειδοποιήσεις για να λαμβάνεις έγκαιρες προειδοποιήσεις για σημαντικές αλλαγές στον καιρό — βροχή, χιόνι ή ακραίες συνθήκες.",
  "intro.notificationsTitle": "Μην χάνεις καμία αλλαγή καιρού",
  "intro.readyDescription": "Απόλαυσε ακριβείς προβλέψεις, ενημερώσεις σε πραγματικό χρόνο και δεδομένα σταθμών από όλο τον κόσμο — όλα σε μία ισχυρή εφαρμογή.",
  "intro.readyTitle": "Είσαι έτοιμος!",
  "intro.welcomeDescription": "Λάβε υπερτοπικές προβλέψεις από κορυφαίες μετεωρολογικές υπηρεσίες και δες πραγματικές καιρικές συνθήκες, παρελθόν και παρόν, από περισσότερους από 40.000 σταθμούς παγκοσμίως.",
  "intro.welcomeTitle": "Ο καιρός σας, ανανεωμένος",
  "landing.alsoAvailableOn": "Διαθέσιμο επίσης στο:",
  "landing.featureAlertsDescription": "Ορίστε προσαρμοσμένα όρια για οποιαδήποτε μέτρηση. Λάβετε ειδοποίηση όταν πέφτει η θερμοκρασία, αρχίζει η βροχή ή δυναμώνει ο άνεμος.",
  "landing.featureAlertsTitle": "Έξυπνες ειδοποιήσεις",
  "landing.featureAnalyticsDescription": "Διαδραστικά γραφήματα, ανάλυση τάσεων και λεπτομερή στατιστικά. Εμβαθύνετε στα δεδομένα θερμοκρασίας, υγρασίας, πίεσης, βροχής και ανέμου.",
  "landing.featureAnalyticsTitle": "Προηγμένη ανάλυση",
  "landing.featureExportDescription": "Λάβετε όλα τα μετεωρολογικά σας δεδομένα με email σε υπολογιστικό φύλλο Excel, έτοιμα για περαιτέρω ανάλυση στο Excel, στο Google Sheets ή στα αγαπημένα σας εργαλεία.",
  "landing.featureExportTitle": "Εξαγωγή των δεδομένων σας",
  "landing.featureForecastDescription": "Πρόσβαση σε {count, plural, one {#+ επαγγελματικό μοντέλο πρόγνωσης} other {#+ επαγγελματικά μοντέλα πρόγνωσης}}, συμπεριλαμβανομένων ECMWF, GFS και περιφερειακών μοντέλων. Συγκρίνετέ τα δίπλα-δίπλα για τις δικές σας προβλέψεις.",
  "landing.featureForecastTitle": "Σύγκριση μοντέλων πρόγνωσης",
  "landing.featureHistoryDescription": "Πρόσβαση σε ιστορικά δεδομένα με ωριαία, ημερήσια και μηνιαία κλίμακα. Εξαγάγετέ τα σε Excel για έρευνα ή προσωπικά αρχεία.",
  "landing.featureHistoryTitle": "Πλούσιο ιστορικό",
  "landing.featureMultiBrandDescription": "Συνδέστε Netatmo, Davis, Tempest, Ecowitt, Ambient Weather και άλλα. Τέλος η εναλλαγή ανάμεσα σε εφαρμογές.",
  "landing.featureMultiBrandTitle": "Όλες οι μάρκες, μία εφαρμογή",
  "landing.featuresSubtitle": "Το SmartMixin σας δίνει τα εργαλεία για να αναλύετε, να συγκρίνετε και να κατανοείτε τα μετεωρολογικά σας δεδομένα σαν επαγγελματίας.",
  "landing.featuresTitle": "Φτιαγμένο για λάτρεις των δεδομένων",
  "landing.finalCtaButton": "Δημιουργία δωρεάν λογαριασμού",
  "landing.finalCtaSubtitle": "Γίνετε μέλος χιλιάδων λάτρεων του καιρού που εμπιστεύονται το SmartMixin.",
  "landing.finalCtaTitle": "Έτοιμοι να εμβαθύνετε στα μετεωρολογικά σας δεδομένα;",
  "landing.heroCta": "Ξεκινήστε δωρεάν",
  "landing.heroDescription": "Εις βάθος αναλύσεις, όμορφα γραφήματα και επαγγελματικές προγνώσεις — όλοι οι μετεωρολογικοί σας σταθμοί ενωμένοι σε μία ισχυρή εφαρμογή.",
  "landing.heroSecondaryCta": "Εξερευνήστε τον χάρτη",
  "landing.heroTagline": "Για λάτρεις του καιρού",
  "landing.heroTitle": "Δείτε τον καιρό σας όπως ποτέ άλλοτε",
  "landing.pricingFeatureAdvancedMetrics": "Προηγμένες μετρήσεις",
  "landing.pricingFeatureAlerts": "Προσαρμοσμένες ειδοποιήσεις",
  "landing.pricingFeatureExport": "Εξαγωγή δεδομένων (Excel)",
  "landing.pricingFeatureForecastComparison": "Σύγκριση προβλέψεων",
  "landing.pricingFeatureForecasts": "Μοντέλα πρόγνωσης",
  "landing.pricingFeatureForecastsFreeTier": "1 μοντέλο",
  "landing.pricingFeatureForecastsPremiumTier": "{count, plural, one {#+ μοντέλο} other {#+ μοντέλα}}",
  "landing.pricingFeatureReports": "Αναλύσεις & αναφορές",
  "landing.pricingFeatureStationComparison": "Σύγκριση σταθμών",
  "landing.pricingFeatureWidgets": "Widgets αρχικής οθόνης",
  "landing.pricingFeatureYearOverYear": "Ανάλυση έτος με έτος",
  "landing.pricingFreeCta": "Ξεκινήστε",
  "landing.pricingFreePrice": "0 €",
  "landing.pricingMostPopular": "Πιο δημοφιλές",
  "landing.pricingPremiumCta": "Ξεκινήστε",
  "landing.pricingPremiumDescription": "Από 1,99 €/μήνα — εγγραφείτε στο web, App Store ή Google Play",
  "landing.pricingSubtitle": "Ξεκινήστε δωρεάν, αναβαθμιστείτε όταν χρειαστείτε περισσότερα.",
  "landing.pricingTitle": "Απλή, διαφανής τιμολόγηση",
  "landing.statBrands": "Υποστηριζόμενες μάρκες",
  "landing.statForecasts": "Μοντέλα πρόγνωσης",
  "landing.statStations": "Μετεωρολογικοί σταθμοί",
  "landing.supportedDevicesNote": "Επιπλέον, πάνω από {count, number} δημόσιοι σταθμοί από το δίκτυο του Παγκόσμιου Μετεωρολογικού Οργανισμού",
  "landing.supportedDevicesSubtitle": "Συνδέστε τον υπάρχοντα μετεωρολογικό σας σταθμό σε λίγα λεπτά. Υποστηρίζουμε {count, plural, one {# μεγάλη μάρκα} other {# μεγάλες μάρκες}} και ο αριθμός αυξάνεται.",
  "landing.supportedDevicesTitle": "Λειτουργεί με τον σταθμό σας",
  "metrics.absolutePressure": "Απόλυτη πίεση",
  "metrics.airDensity": "Πυκνότητα αέρα",
  "metrics.airGap": "Διάκενο αέρα",
  "metrics.apparentTemperature": "Φαινόμενη θερμοκρασία",
  "metrics.AQI": "AQI",
  "metrics.AQI_24H": "24h AQI",
  "metrics.avg": "Μέσος όρος",
  "metrics.avg_wind": "Μέσος όρος ανέμου",
  "metrics.beaufort": "Μποφόρ",
  "metrics.blackGlobeTemperature": "Θερμ. μαύρης σφαίρας",
  "metrics.boilerOn": "Λέβητας σε λειτουργία",
  "metrics.boilerOnInHours": "Λέβητας σε λειτουργία (ώρες)",
  "metrics.co2": "CO2",
  "metrics.conductivity": "Αγωγιμότητα",
  "metrics.dailyPrecipitation": "Ημερήσιος υετός",
  "metrics.dailyRain": "Ημερήσια βροχή",
  "metrics.degreeDayShort": "Βαθμός ημέρας",
  "metrics.depth": "Βάθος",
  "metrics.depthSensors": "Αισθητήρες βάθους",
  "metrics.dewPoint": "Σημείο δρόσου",
  "metrics.distance": "Απόσταση",
  "metrics.downTrend": "κάτω",
  "metrics.ET": "Εξατμισοδιαπνοή",
  "metrics.etToday": "Εξατμισοδιαπνοή σήμερα",
  "metrics.feelsLike": "Αισθητή θερμοκρασία",
  "metrics.feelsLikeWithFormula": "Αισθητή θερμοκρασία ({formula})",
  "metrics.frostPoint": "Σημείο παγετού",
  "metrics.gust": "Ριπή",
  "metrics.hail": "Χαλάζι",
  "metrics.heatIndex": "Δείκτης θερμότητας",
  "metrics.heatingDegreeDays": "Βαθμοημέρες θέρμανσης",
  "metrics.heatingPower": "Ισχύς θέρμανσης",
  "metrics.humidex": "Δείκτης δυσφορίας Humidex",
  "metrics.humidity": "Υγρασία",
  "metrics.lastLightningImpact": "Τελευταίος κεραυνός",
  "metrics.lastMeasure": "Τελευταία μέτρηση",
  "metrics.leafSensors": "Αισθητήρες φύλλων",
  "metrics.leafWetness": "Υγρασία φύλλων",
  "metrics.lightningDistance": "Απόσταση",
  "metrics.lightningStrikeCount": "Μετρητής κεραυνών",
  "metrics.lightningStrikeDistance": "Απόσταση κεραυνού",
  "metrics.max": "Μέγιστη",
  "metrics.max_gust": "Μέγιστη ριπή",
  "metrics.maxToday": "Μέγ. σήμερα",
  "metrics.min": "Ελάχιστη",
  "metrics.noise": "Θόρυβος",
  "metrics.normalizedHeatingCoefficient": "Προσαρμοσμένος συντελεστής θέρμανσης",
  "metrics.outdoorTemperature": "Εξωτερική θερμοκρασία",
  "metrics.PM_1": "PM1",
  "metrics.PM_10": "PM10",
  "metrics.PM_2P5": "PM2,5",
  "metrics.precipitation": "Βροχόπτωση",
  "metrics.pressure": "Πίεση",
  "metrics.rain": "Βροχή",
  "metrics.rainDurationValue": "Διάρκεια βροχής: {duration}",
  "metrics.rainfallMeasurement": "Μέτρηση βροχόπτωσης",
  "metrics.rainRate": "Ένταση βροχής",
  "metrics.relativePressure": "Σχετική πίεση",
  "metrics.setPoint": "Σημείο ρύθμισης",
  "metrics.snow": "Χιόνι",
  "metrics.snowfall": "Χιονόπτωση",
  "metrics.soilMoisture": "Υγρασία",
  "metrics.soilSensors": "Αισθητήρες εδάφους",
  "metrics.soilWaterTension": "Τάση νερού εδάφους",
  "metrics.solarEnergy": "Ηλιακή ενέργεια",
  "metrics.solarRadiation": "Ηλιακή ακτινοβολία",
  "metrics.speed": "Ταχύτητα",
  "metrics.stableTrend": "σταθερό",
  "metrics.sum": "Άθροισμα",
  "metrics.temperature": "Θερμοκρασία",
  "metrics.temperatureSensors": "Αισθητήρες θερμοκρασίας και υγρασίας αέρος",
  "metrics.temperatureShort": "Θερμ.",
  "metrics.thsw": "THSW",
  "metrics.thw": "THW",
  "metrics.upTrend": "Αυξητική τάση",
  "metrics.uv": "UV",
  "metrics.visibility": "Ορατότητα",
  "metrics.weatherCondition": "Καιρικές συνθήκες",
  "metrics.wetBulbGlobeTemperature": "Θερμ. WBGT",
  "metrics.wetBulbTemperature": "Θερμ. υγρού θερμομέτρου",
  "metrics.wind": "Άνεμος",
  "metrics.windChill": "Ψυχρότητα ανέμου",
  "metrics.windDirection": "Κατεύθυνση ανέμου",
  "metrics.windMeasurement": "Μέτρηση ανέμου",
  "metrics.windRun": "Διαδρομή ανέμου",
  "metrics.windRunDescription": "Η διαδρομή του ανέμου είναι η συνολική απόσταση που διανύει ο άνεμος κατά τη διάρκεια μιας χρονικής περιόδου",
  "metrics.windSpeed": "Ταχύτητα ανέμου",
  "network.cancelError": "Το αίτημα έχει ακυρωθεί",
  "network.connectionError": "Ο διακομιστής (Server) δεν είναι διαθέσιμος",
  "network.networkError": "Το δίκτυο δεν είναι διαθέσιμο",
  "network.serverError": "Κάτι πήγε λάθος...",
  "network.timeoutError": "Λήξη χρόνου σύνδεσης",
  "network.unknownError": "Άγνωστο λάθος",
  "premium.alreadyPremium": "Έχετε ήδη λογαριασμό premium!",
  "premium.bestValue": "Καλύτερη προσφορά",
  "premium.billingDetailsAndroid": "Δωρεάν δοκιμή: δεν θα χρεωθείτε αν ακυρώσετε τουλάχιστον 24 ώρες πριν από τη λήξη της δοκιμής. Στη συνέχεια, η συνδρομή σας στο SmartMixin ανανεώνεται αυτόματα, εκτός αν την ακυρώσετε τουλάχιστον 24 ώρες πριν από τη λήξη της τρέχουσας περιόδου· μπορείτε να την ακυρώσετε οποιαδήποτε στιγμή από τις ρυθμίσεις του λογαριασμού σας στο Google Play. Κάθε ανανέωση χρεώνεται στην τιμή που εμφανίζεται στο κουμπί παραπάνω. Η πληρωμή χρεώνεται στον λογαριασμό σας στο Google Play κατά την επιβεβαίωση της αγοράς και στην αρχή κάθε περιόδου ανανέωσης.",
  "premium.billingDetailsIos": "Δωρεάν δοκιμή: δεν θα χρεωθείτε αν ακυρώσετε τουλάχιστον 24 ώρες πριν από τη λήξη της δοκιμής. Στη συνέχεια, η συνδρομή σας στο SmartMixin ανανεώνεται αυτόματα, εκτός αν την ακυρώσετε τουλάχιστον 24 ώρες πριν από τη λήξη της τρέχουσας περιόδου· μπορείτε να την ακυρώσετε οποιαδήποτε στιγμή από τις ρυθμίσεις του λογαριασμού σας στο App Store. Κάθε ανανέωση χρεώνεται στην τιμή που εμφανίζεται στο κουμπί παραπάνω. Η πληρωμή χρεώνεται στον λογαριασμό σας στο App Store κατά την επιβεβαίωση της αγοράς και στην αρχή κάθε περιόδου ανανέωσης.",
  "premium.freeBannerBody": "Οι δωρεάν λογαριασμοί λαμβάνουν GFS παντού — τα προτιμώμενα μοντέλα σας και το «παντού αλλού» αρχίζουν να ισχύουν μόλις γίνετε συνδρομητής.",
  "premium.freeBannerTitle": "Οι προτιμήσεις ισχύουν με Premium",
  "premium.freeSubscription": "Δωρεάν συνδρομή premium",
  "premium.freeTrialForPeriod": "Δωρεάν δοκιμή για {period, plural, one {# ημέρα} other {# ημέρες}}",
  "premium.getUnlimitedAccess": "Απεριόριστη πρόσβαση σε:",
  "premium.manageMySubscription": "Διαχείριση της συνδρομής μου",
  "premium.notPurchasedYet": "Δεν βρέθηκε αγορά του SmartMixin Premium για αυτόν τον λογαριασμό καταστήματος.",
  "premium.orChooseMonthly": "Ή επιλέξτε μηνιαία:",
  "premium.premium": "SmartMixin Premium",
  "premium.premiumActive": "Ενεργό",
  "premium.premiumAnnualTrialInfo": "Ξεκινήστε με δωρεάν δοκιμαστική περίοδο {days, plural, one {# ημέρας} other {# ημερών}}",
  "premium.premiumCurrentPlan": "Τρέχον πρόγραμμα",
  "premium.premiumDownloadApp": "Κατεβάστε την εφαρμογή για να εγγραφείτε:",
  "premium.premiumEndsOn": "Λήγει στις {date}",
  "premium.premiumFeatureAlerts": "Ειδοποιήσεις καιρού",
  "premium.premiumFeatureAnalysis": "Προηγμένη ανάλυση καιρού",
  "premium.premiumFeatureCharts": "Συγκρίσεις γραφημάτων",
  "premium.premiumFeatureExport": "Εξαγωγή δεδομένων",
  "premium.premiumFeatureForecast": "Περιφερειακά μοντέλα πρόγνωσης",
  "premium.premiumFeatureNotification": "Widget γραμμής κατάστασης",
  "premium.premiumFeatureTitle": "Λειτουργία Premium",
  "premium.premiumFeatureWidgets": "Widgets αρχικής οθόνης",
  "premium.premiumFreePlan": "Δωρεάν",
  "premium.premiumInactive": "Χωρίς συνδρομή",
  "premium.premiumManageStoreSubscription": "Εγγραφήκατε μέσω {store}. Διαχειριστείτε ή ακυρώστε τη συνδρομή σας εκεί.",
  "premium.premiumManageWebSubscription": "Διαχειριστείτε τη συνδρομή σας, ενημερώστε τον τρόπο πληρωμής ή ακυρώστε.",
  "premium.premiumPremiumPlan": "Premium",
  "premium.premiumRenewsOn": "Ανανεώνεται στις {date}",
  "premium.premiumSubscribeAnnual": "Ετήσια — 9,99 €/έτος",
  "premium.premiumSubscribedOn": "Εγγραφή μέσω {platform}",
  "premium.premiumSubscribedOnWeb": "Συνδρομή μέσω web",
  "premium.premiumSubscribeMonthly": "Μηνιαία — 1,99 €/μήνα",
  "premium.premiumSubscribeOnWeb": "Εγγραφείτε τώρα για να ξεκλειδώσετε όλες τις premium λειτουργίες.",
  "premium.premiumSubscriptionSuccess": "Η συνδρομή σας ενεργοποιήθηκε! Απολαύστε όλες τις premium λειτουργίες.",
  "premium.premiumSubscriptionSuccessTitle": "Καλώς ήρθατε στο Premium!",
  "premium.premiumWebappNotice": "Η εγγραφή συνδρομής μέσω web δεν είναι διαθέσιμη αυτήν τη στιγμή.",
  "premium.pricePerMonth": "{price}/μήνα",
  "premium.pricePerYear": "{price}/έτος",
  "premium.purchasedNetatmoPro": "Αγοράσατε προηγουμένως το Netatmo Pro ({date}). Σας δίνει πρόσβαση σε ένα υποσύνολο premium λειτουργιών. Εγγραφείτε σε μία από τις παρακάτω προσφορές αν θέλετε να έχετε πρόσβαση σε όλες τις premium λειτουργίες.",
  "premium.purchaseFailed": "Δεν ήταν δυνατή η ολοκλήρωση της αγοράς. Δοκιμάστε ξανά.",
  "premium.restoreFailed": "Δεν ήταν δυνατή η επαναφορά των αγορών σας. Δοκιμάστε ξανά.",
  "premium.restorePurchase": "Επαναφορά αγοράς",
  "premium.savingsPercent": "Εξοικονόμηση {percent}%",
  "premium.seePremium": "Δείτε το Premium",
  "premium.startFreeTrial": "Έναρξη δωρεάν δοκιμής",
  "premium.storeUnavailable": "Το κατάστημα δεν είναι διαθέσιμο αυτή τη στιγμή. Δοκιμάστε ξανά αργότερα.",
  "premium.subscribeNow": "Εγγραφή τώρα — χωρίς δοκιμαστική περίοδο",
  "premium.switchToPremium": "Αλλαγή σε SmartMixin Premium",
  "premium.thenPrice": "μετά {price}",
  "providerHints.ambientWeatherApiKey": "Δημιουργείται στις ρυθμίσεις του λογαριασμού σας στο ambientweather.net.",
  "providerHints.davisApiSecret": "Εμφανίζεται μόνο μία φορά κατά τη δημιουργία του κλειδιού V2 API — φυλάξτε το με ασφάλεια.",
  "providerHints.davisV2ApiKey": "Από τη σελίδα κλειδιών V2 API στο weatherlink.com.",
  "providerHints.ecowittApi": "Από τη σελίδα API του λογαριασμού σας Ecowitt.",
  "providerHints.ecowittApp": "Το κλειδί εφαρμογής, επίσης από τον λογαριασμό σας Ecowitt.",
  "providerHints.myAcuriteCredentialsBanner": "Χρησιμοποιήστε email και κωδικό του λογαριασμού σας My AcuRite — όχι τη σύνδεση SmartMixin.",
  "providerHints.myAcuriteEmail": "Το email του λογαριασμού σας My AcuRite — όχι η σύνδεσή σας στο SmartMixin.",
  "providerHints.myAcuritePassword": "Ο κωδικός του λογαριασμού σας My AcuRite.",
  "providerHints.weatherflowToken": "Προσωπικό token από tempestwx.com → ρυθμίσεις → εξουσιοδοτήσεις δεδομένων.",
  "providerHints.wundergroundEditKey": "Χρήση άλλου κλειδιού",
  "providerHints.wundergroundKey": "Μια μακριά συμβολοσειρά από τη σελίδα κλειδιών API του λογαριασμού σας Weather Underground — όχι ο κωδικός σας στο wunderground.com.",
  "providerHints.wundergroundKeyExample": "π.χ. 5f6a7b8c9dabcdef…",
  "providerHints.wundergroundKeyVerified": "Το κλειδί API επαληθεύτηκε",
  "providerHints.wundergroundNoStationsNearby": "Δεν βρέθηκαν σταθμοί κοντά σε αυτή την τοποθεσία. Δοκιμάστε να εισαγάγετε απευθείας ID σταθμού.",
  "providerHints.wundergroundStationIdExample": "π.χ. KCASANFR123",
  "providerIntro.ambientWeatherStep2": "Πάρτε το κλειδί API Ambient Weather.",
  "providerIntro.davisStep2": "Πάρτε το κλειδί V2 API και το μυστικό API Davis.",
  "providerIntro.ecowittStep2": "Πάρτε το κλειδί API και το κλειδί εφαρμογής Ecowitt.",
  "providerIntro.getStarted": "Ξεκινήστε",
  "providerIntro.myAcuriteStep2": "Χρησιμοποιήστε email και κωδικό του υπάρχοντος λογαριασμού σας My AcuRite.",
  "providerIntro.netatmoEnergyStep2": "Συνδεθείτε στο Netatmo όταν σας ζητηθεί — δεν απαιτείται κλειδί API.",
  "providerIntro.netatmoWeatherStep2": "Συνδεθείτε στο Netatmo όταν σας ζητηθεί — δεν απαιτείται κλειδί API.",
  "providerIntro.signupBanner": "Σχεδόν τελειώσατε — δημιουργήστε τον δωρεάν λογαριασμό σας SmartMixin για να συνδέσετε το {provider}.",
  "providerIntro.step1": "Συνδεθείτε στον λογαριασμό σας SmartMixin (ΟΧΙ στο {provider}).",
  "providerIntro.step3EmailPassword": "Εισαγάγετε τα εδώ.",
  "providerIntro.step3KeyOrToken": "Επικολλήστε εδώ.",
  "providerIntro.step3OAuth": "Εξουσιοδοτήστε το SmartMixin στο αναδυόμενο παράθυρο.",
  "providerIntro.step3Wunderground": "Επικολλήστε το κλειδί API σας και στη συνέχεια επιλέξτε έναν κοντινό σταθμό ή εισαγάγετε οποιοδήποτε ID σταθμού.",
  "providerIntro.title": "Σύνδεση {provider}",
  "providerIntro.weatherflowStep2": "Πάρτε το προσωπικό σας token Tempest.",
  "providerIntro.wundergroundBrowsePublic": "Δεν έχετε σταθμό; Περιηγηθείτε στους δημόσιους",
  "providerIntro.wundergroundFindNearby": "Βρείτε σταθμούς κοντά μου",
  "providerIntro.wundergroundOrEnterId": "Ή εισαγάγετε ID σταθμού",
  "providerIntro.wundergroundStep2": "Πάρτε το κλειδί API Weather Underground. Στη συνέχεια θα μπορείτε να συνδέσετε οποιονδήποτε σταθμό — δικό σας ή δημόσιο.",
  "reports.agroMeteorology": "Αγρομετεωρολογία",
  "reports.analysis": "Ανάλυση",
  "reports.annualCumulativeRainfallComparison": "Σύγκριση συνόλου ετήσιας βροχόπτωσης",
  "reports.annualHeatingDurationComparison": "Σύγκριση ετήσιας διάρκειας θέρμανσης",
  "reports.annualHeatingEfficiency": "Ετήσια απόδοση θέρμανσης",
  "reports.annualIndoorComparison": "Ετήσια σύγκριση εσωτερικού χώρου",
  "reports.annualOutdoorComparison": "Ετήσια σύγκριση εξωτερικού χώρου",
  "reports.annualOutdoorReport": "Ετήσια αναφορά εξωτερικού χώρου",
  "reports.annualReport": "Ετήσια αναφορά",
  "reports.annualSolarReport": "Ετήσια αναφορά ηλιακής ενέργειας",
  "reports.annualWaterBalance": "Ετήσιο ισοζύγιο νερού",
  "reports.annualWaterBalanceCarryOver": "Μεταφορά από το {year} ({value})",
  "reports.annualWaterBalanceDescription": "Το ισοζύγιο νερού (απλουστευμένη έκδοση, χρησιμοποιούνται μόνο η βροχή και η εξατμισοδιαπνοή) συμβάλλει στη διαχείριση της προσφοράς νερού.",
  "reports.avgHumidity": "Μέση υγρασία",
  "reports.avgMaxTemperature": "Μέσος όρος T°max",
  "reports.avgMetric": "Μέσος όρος – {metric}",
  "reports.avgMinTemperature": "Μέσος όρος T°min",
  "reports.avgPressure": "Μέση πίεση",
  "reports.avgTemperature": "Μέση θερμοκρασία",
  "reports.chartsAndTable": "Διαγράμματα και πίνακας",
  "reports.climateNormalPeriodOfRecord": "Περίοδος καταγραφής ({years, plural, one {# έτος} other {# έτη}})",
  "reports.climateNormals": "Κλιματικές κανονικές τιμές",
  "reports.climateNormalStandardLabel": "Τυπική κανονική τιμή ({period})",
  "reports.climateTrendPerDecade": "Τάση θερμοκρασίας: {value} ανά δεκαετία σε διάστημα {years, plural, one {# έτους} other {# ετών}}",
  "reports.coldestMonthRanking": "Ψυχρότερος {month} όλων των εποχών",
  "reports.comfortable": "Άνετη (45% {lessThan} Υγρασία ≤ 60%)",
  "reports.cumulativeRainfall": "Συσσωρευτική βροχόπτωση",
  "reports.cumulativeRainfallDescription": "Παρακολουθήστε τη συνολική βροχόπτωση που συσσωρεύεται στην επιλεγμένη περίοδο.",
  "reports.dailyMaxRainfall": "Μέγιστη ημερήσια βροχόπτωση",
  "reports.dataExport": "Εξαγωγή δεδομένων",
  "reports.dataExportXlsxFormatDescription": "Εξάγετε όλα τα δεδομένα του σταθμού σας σε μορφή Excel (*.xlsx). Μόλις κάνετε κλικ στο κουμπί, θα λάβετε ένα μήνυμα ηλεκτρονικού ταχυδρομείου με τα επεξεργασμένα δεδομένα μετά από λίγα λεπτά",
  "reports.daysOfData": "{days, plural, one {# ημέρα} other {# ημέρες}} δεδομένων",
  "reports.daysWithFrost": "Ημέρες με παγετό",
  "reports.daysWithHeavyRain": "Ημέρες με έντονη βροχή (≥ {threshold})",
  "reports.daysWithoutThaw": "Ημέρες χωρίς απόψυξη",
  "reports.daysWithStrongFrost": "Ημέρες με ισχυρό παγετό",
  "reports.emailSent": "Ένα email έχει σταλεί στο γραμματοκιβώτιο σας",
  "reports.frostDays": "Ημέρες παγετού",
  "reports.grasslandTemperatureSum": "Συνολική θερμοκρασία λιβαδιών (Αγρομετεωρολογία ένδειξη GTS)",
  "reports.grasslandTemperatureSumDescription": "Εάν την άνοιξη το άθροισμα του {threshold} ξεπεραστεί, η βιώσιμη έναρξη της βλάστησης έχει επιτευχθεί (εφαρμόζεται στην Ευρώπη).",
  "reports.growingDegreeDays": "Βαθμοημέρες ανάπτυξης",
  "reports.highPressure": "Αντικυκλώνας (Μέση πίεση ≥ 1013mbar)",
  "reports.iceDays": "Ημέρες συνεχούς παγετού",
  "reports.indoorReport": "Αναφορά εσωτερικών χώρων",
  "reports.keyFacts": "Βασικά γεγονότα",
  "reports.longestDrySpell": "Μεγαλύτερη ξηρή περίοδος",
  "reports.longestRunOfRainyDays": "Η μεγαλύτερη διάρκεια βροχερών ημερών",
  "reports.longestRunWithoutRun": "Το μεγαλύτερο χρονικό διάστημα χωρίς βροχή",
  "reports.longestWetSpell": "Μεγαλύτερη βροχερή περίοδος",
  "reports.lowPressure": "Χαμηλή πίεση (Μέση πίεση {lessThan} 1013mbar)",
  "reports.maxHumidity": "Μέγιστη υγρασία",
  "reports.maxMetric": "Μέγιστο – {metric}",
  "reports.maxPressure": "Μέγιστη πίεση",
  "reports.maxTemperature": "Μέγιστη θερμοκρασία",
  "reports.maxTempGreaterThan": "T°max ≥",
  "reports.maxTempMagnitude24h": "Μέγιστο εύρος (/24h)",
  "reports.minHumidity": "Ελάχιστη υγρασία",
  "reports.minMetric": "Ελάχιστο – {metric}",
  "reports.minPressure": "Ελάχιστη πίεση",
  "reports.minTemperature": "Ελάχιστη θερμοκρασία",
  "reports.minTempMagnitude24h": "Ελάχιστο εύρος (/24h)",
  "reports.monthlyAverageCountdown": "{days, plural, one {# ακόμη ημέρα} other {# ακόμη ημέρες}} αυτόν τον μήνα",
  "reports.monthlyAverageCountdownDetail": "Τότε εμφανίζονται ο μέσος όρος του μήνα και η κατάταξή του.",
  "reports.monthlyAverageRule": "Οι μηνιαίοι μέσοι όροι και οι κατατάξεις εμφανίζονται όταν ένας ημερολογιακός μήνας έχει {days, plural, one {# καταγεγραμμένη ημέρα} other {# καταγεγραμμένες ημέρες}}.",
  "reports.monthlyHeatingEfficiency": "Μηνιαία αποτελεσματικότητα θέρμανσης",
  "reports.monthlyOutdoorReport": "Μηνιαία αναφορά εξωτερικού χώρου",
  "reports.monthlyReport": "Μηνιαία αναφορά",
  "reports.monthlySolarReport": "Μηνιαία αναφορά ηλιακής ενέργειας",
  "reports.monthlyWindReport": "Μηνιαία αναφορά ανέμου",
  "reports.monthsOfData": "{months, plural, one {# μήνας} other {# μήνες}} δεδομένων",
  "reports.numberOfDays": "Αριθμός ημερών",
  "reports.outdoorReport": "Αναφορά εξωτερικού χώρου",
  "reports.overviewSection": "Επισκόπηση",
  "reports.rainfall": "Βροχόπτωση",
  "reports.rainyDays": "Βροχερές μέρες",
  "reports.recordDailyRain": "Πιο βροχερή ημέρα",
  "reports.recordHigh": "Ρεκόρ ζέστης",
  "reports.recordLow": "Ρεκόρ ψύχους",
  "reports.recordsAndClimatology": "Ρεκόρ και κλίμα",
  "reports.recordsSince": "Ρεκόρ από {date}",
  "reports.recordWindGust": "Ισχυρότερη ριπή ανέμου",
  "reports.relativelyWet": "Σχετικά υγρό (60% {lessThan} υγρασία ≤ 80%)",
  "reports.sectionReportCount": "{count, plural, one {# αναφορά} other {# αναφορές}}",
  "reports.sendEmail": "Αποστολή email",
  "reports.summerDays": "Θερινές ημέρες",
  "reports.tooDry": "Πολύ ξηρό (υγρασία ≤ 45%)",
  "reports.tooWet": "Πολύ υγρό (υγρασία {greaterThan} 80%)",
  "reports.tropicalNights": "Τροπικές νύχτες",
  "reports.unlockPremiumSubtitle": "Περιλαμβάνεται στο SmartMixin Premium",
  "reports.unlockPremiumTitle": "Ξεκλειδώστε {count, plural, one {# premium λειτουργία} other {# premium λειτουργίες}}",
  "reports.warmestMonthRanking": "Θερμότερος {month} όλων των εποχών",
  "reports.waterBalance": "Ισοζύγιο νερού",
  "reports.yearsOfData": "{years, plural, one {# χρόνος} other {# χρόνια}} δεδομένων",
  "reports.yearToDateTemperatureComparison": "Σύγκριση θερμοκρασίας από την αρχή του έτους",
  "sensors.bgtSensors": "Μαύρη σφαίρα & WBGT",
  "sensors.cameraFeed": "Κάμερα",
  "sensors.compareHumidity": "Σύγκριση υγρασίας",
  "sensors.compareMoisture": "Σύγκριση εδαφικής υγρασίας",
  "sensors.comparePm25": "Σύγκριση PM2.5",
  "sensors.compareTemperatures": "Σύγκριση θερμοκρασιών",
  "sensors.compareWaterTension": "Σύγκριση τάσης νερού εδάφους",
  "sensors.depthByChannel": "Βάθος ανά κανάλι",
  "sensors.heatStressExtreme": "Ακραία θερμική καταπόνηση",
  "sensors.heatStressModerate": "Μέτρια θερμική καταπόνηση",
  "sensors.heatStressNone": "Χωρίς θερμική καταπόνηση",
  "sensors.heatStressStrong": "Ισχυρή θερμική καταπόνηση",
  "sensors.heatStressVeryStrong": "Πολύ ισχυρή θερμική καταπόνηση",
  "sensors.indoorClimate": "Εσωτερικό κλίμα",
  "sensors.indoorCo2Levels": "Επίπεδα CO2",
  "sensors.indoorTemperatureAndHumidity": "Θερμοκρασία & υγρασία",
  "sensors.leafWetnessByChannel": "Υγρασία φύλλων ανά κανάλι",
  "sensors.lightningSensor": "Κεραυνός",
  "sensors.moistureByChannel": "Εδαφική υγρασία ανά κανάλι",
  "sensors.noDataAvailable": "Δεν υπάρχουν διαθέσιμα δεδομένα",
  "sensors.pm10AndAqi": "PM10 & AQI",
  "sensors.pm1AndAqi": "PM1.0 & AQI",
  "sensors.pm25AndAqi": "PM2.5 & AQI",
  "sensors.pm25ByChannel": "PM2.5 ανά κανάλι",
  "sensors.pm4AndAqi": "PM4.0 & AQI",
  "sensors.selectChannel": "Επιλέξτε κανάλι",
  "sensors.sensorDetailDescription": "Προβολή ιστορικών δεδομένων και τάσεων για τα κανάλια του αισθητήρα.",
  "sensors.sensorHistory": "Ιστορικό αισθητήρα",
  "sensors.soilConductivityByChannel": "Αγωγιμότητα ανά κανάλι",
  "sensors.soilTemperatureByChannel": "Θερμοκρασία εδάφους ανά κανάλι",
  "sensors.strikesToday": "Κεραυνοί σήμερα",
  "sensors.temperatureByChannel": "Θερμοκρασία ανά κανάλι",
  "sensors.viewChart": "Προβολή γραφήματος",
  "sensors.waterTensionByChannel": "Τάση νερού εδάφους ανά κανάλι",
  "settings.appearance": "Εμφάνιση",
  "settings.appVersion": "SmartMixin v{version}",
  "settings.arabic": "Αραβικά",
  "settings.bulgarian": "Βουλγαρικά",
  "settings.catalan": "Καταλανικά",
  "settings.chartGestures": "Κινήσεις σε διαγράμματα",
  "settings.chartGesturesDescription": "Το σύρσιμο στα διαγράμματα αλλάζει τη χρονική περίοδο, το τσίμπημα των διαγραμμάτων αλλάζει τη χρονική κλίμακα",
  "settings.choiceCount": "{count, plural, one {# διαθέσιμη} other {# διαθέσιμες}}",
  "settings.contactUs": "Επικοινωνήστε μαζί μας",
  "settings.contactUsDescription": "Λάβετε βοήθεια ή στείλτε σχόλια",
  "settings.croatian": "Κροατικά",
  "settings.czech": "Τσέχικα",
  "settings.dailyDetailByPeriods": "Ημερήσιες λεπτομέρειες ανά περίοδο",
  "settings.dailyDetailByPeriodsDescription": "Ομαδοποίηση των 24 ωρών σε νύχτα, πρωί, απόγευμα και βράδυ — ο ίδιος διαχωρισμός που χρησιμοποιεί η ημερήσια περίληψη.",
  "settings.danish": "Δανικά",
  "settings.dark": "Σκοτεινή εμφάνιση",
  "settings.dataDisplay": "Εμφάνιση δεδομένων",
  "settings.dateAndTime": "Ημερομηνία και ώρα",
  "settings.donateButton": "Κάντε μια δωρεά",
  "settings.donateDescription": "Το SmartMixin αναπτύσσεται από μια μικρή ομάδα. Αν σας φαίνεται χρήσιμο, μπορείτε να στηρίξετε την ανάπτυξή του με μια εφάπαξ δωρεά οποιουδήποτε ποσού. Είναι ένα δώρο — δεν αλλάζει το πρόγραμμά σας και δεν ξεκλειδώνει καμία λειτουργία.",
  "settings.donateSuccessBody": "Η δωρεά σας βοηθά το SmartMixin να συνεχίσει να λειτουργεί και να βελτιώνεται. Το εκτιμούμε ειλικρινά.",
  "settings.donateSuccessTitle": "Σας ευχαριστούμε για την υποστήριξη!",
  "settings.donateTitle": "Υποστηρίξτε το SmartMixin",
  "settings.dragToReorder": "Σύρετε για αναδιάταξη",
  "settings.dutch": "Ολλανδικά",
  "settings.english": "Αγγλικά",
  "settings.french": "Γαλλικά",
  "settings.german": "Γερμανικά",
  "settings.gestures": "Κινήσεις",
  "settings.greek": "Ελληνικά",
  "settings.hungarian": "Ουγγρικά",
  "settings.italian": "Ιταλικά",
  "settings.japanese": "Ιαπωνικά",
  "settings.korean": "Κορεάτικα",
  "settings.language": "Γλώσσα",
  "settings.languageDescription": "Προτιμώμενη γλώσσα",
  "settings.light": "Φωτεινή εμφάνιση",
  "settings.measurementUnits": "Μονάδες μέτρησης",
  "settings.netatmoDashboard": "Πίνακας Netatmo",
  "settings.netatmoLayoutCards": "Λίστα καρτών",
  "settings.netatmoLayoutCardsDescription": "Μία κάρτα ανά μονάδα, όλα σε μία κύλιση",
  "settings.netatmoLayoutClassic": "Κλασική",
  "settings.netatmoLayoutClassicDescription": "Δύο κάρτες, εναλλαγή μεταξύ μονάδων",
  "settings.netatmoNewLayoutNotice": "Νέα διάταξη πίνακα: μία κάρτα ανά μονάδα.",
  "settings.netatmoSwitchBackToClassic": "Επιστροφή στην κλασική",
  "settings.netatmoSwitchToLayout": "Εναλλαγή σε {layout}",
  "settings.norwegian": "Νορβηγικά",
  "settings.notificationsSection": "Ειδοποιήσεις",
  "settings.ongoingNotificationEnabled": "Ενεργοποίηση μόνιμης ειδοποίησης",
  "settings.ongoingNotificationMetrics": "Εμφανιζόμενες μετρήσεις",
  "settings.ongoingNotificationPermissionRequired": "Απαιτείται άδεια ειδοποιήσεων",
  "settings.ongoingNotificationPreviewHint": "Προεπισκόπηση — ενεργοποιήστε το widget για να εμφανιστεί",
  "settings.ongoingNotificationStatusBar": "Γραμμή κατάστασης",
  "settings.polish": "Πολωνικά",
  "settings.portuguese": "Πορτογαλικά",
  "settings.preferencesSection": "Προτιμήσεις",
  "settings.privacyPolicy": "Πολιτική απορρήτου",
  "settings.russian": "Ρωσικά",
  "settings.serbian": "Σέρβικα",
  "settings.settings": "Ρυθμίσεις",
  "settings.settingsPageTitle": "Ρυθμίσεις - {page}",
  "settings.slovak": "Σλοβάκικα",
  "settings.smallDecimals": "Μικρά δεκαδικά",
  "settings.smallDecimalsDescription": "Εμφάνιση δεκαδικών ψηφίων σε μικρότερο μέγεθος",
  "settings.spanish": "Ισπανικά",
  "settings.statusBarWidget": "Widget γραμμής κατάστασης",
  "settings.statusBarWidgetDescription": "Πάντα ορατά δεδομένα καιρού",
  "settings.subscriptionSection": "Συνδρομή",
  "settings.supportSection": "Υποστήριξη",
  "settings.swedish": "Σουηδικά",
  "settings.systemTheme": "Εμφάνιση συστήματος",
  "settings.termsOfService": "Όροι παροχής υπηρεσιών",
  "settings.turkish": "Τουρκικά",
  "settings.ukrainian": "Ουκρανικά",
  "settings.units": "Μονάδες",
  "settings.unitsDescription": "Μονάδες μέτρησης που εμφανίζονται στην εφαρμογή",
  "settings.update": "Ενημέρωση",
  "settings.windDirectionConvention": "Βέλος κατεύθυνσης ανέμου",
  "settings.windDirectionConventionDescription": "Επιλέξτε πώς εμφανίζονται τα βέλη κατεύθυνσης ανέμου",
  "settings.windDirectionMeteorological": "Κατεύθυνση προέλευσης",
  "settings.windDirectionMeteorologicalDescription": "Το βέλος δείχνει από πού έρχεται ο άνεμος (μετεωρολογική σύμβαση)",
  "settings.windDirectionOceanographic": "Κατεύθυνση ροής",
  "settings.windDirectionOceanographicDescription": "Το βέλος δείχνει προς τα πού φυσά ο άνεμος (ωκεανογραφική σύμβαση)",
  "stations.addAStation": "Πρόσθεση σταθμού",
  "stations.addToFavorites": "Προσθήκη στα αγαπημένα",
  "stations.addYourOwnStation": "Προσθέστε το δικό σας σταθμό",
  "stations.clearRecentLocations": "Εκκαθάριση όλων",
  "stations.clearSearch": "Εκκαθάριση αναζήτησης",
  "stations.currentLocation": "Τρέχουσα τοποθεσία",
  "stations.customizedStationName": "Προσαρμοσμένο όνομα σταθμού",
  "stations.favoriteLocations": "Αγαπημένα",
  "stations.favoriteLocationsEmpty": "Μπορείτε να προσθέσετε έως και 5 αγαπημένες τοποθεσίες.",
  "stations.favoriteStations": "Αγαπημένοι σταθμοί",
  "stations.filterStationDescription": "Να μην εμφανίζονται σταθμοί με αναξιόπιστες μετρήσεις",
  "stations.filterStations": "Φίλτρα σταθμών",
  "stations.filterStationSourceDescription": "Επιλέξτε τους παρόχους σταθμών που θέλετε να εμφανίσετε στον χάρτη",
  "stations.findStationsNearYou": "Βρείτε σταθμούς κοντά σας",
  "stations.hiddenStations": "Κρυμμένοι σταθμοί",
  "stations.hiddenStationsDescription": "Μπορείτε να εμφανίσετε ξανά έναν σταθμό πατώντας το εικονίδιο του ματιού δίπλα του.",
  "stations.lastSeen": "τελευταία {time}",
  "stations.location": "Τοποθεσία",
  "stations.locationAddedToFavorites": "Η τοποθεσία προστέθηκε στα αγαπημένα",
  "stations.locationNotGranted": "Η άδεια τοποθεσίας δεν χορηγείται. Επιτρέψτε την πρόσβαση στην τοποθεσία σας στις ρυθμίσεις της συσκευής.",
  "stations.locationRemovedFromFavorites": "Η τοποθεσία αφαιρέθηκε από τα αγαπημένα",
  "stations.locations": "Τοποθεσίες",
  "stations.locationUnavailable": "Δεν ήταν δυνατή η λήψη της τοποθεσίας σας. Ελέγξτε τις ρυθμίσεις της συσκευής σας.",
  "stations.maxFavoriteLocationsReached": "Μπορείτε να έχετε έως 5 αγαπημένες τοποθεσίες. Αφαιρέστε μία για να προσθέσετε άλλη.",
  "stations.modifyFavoriteStations": "Τροποποιήστε τους αγαπημένους σταθμούς",
  "stations.modifyFavoriteStationsDescription": "Μπορείτε να αλλάξετε τη σειρά των αγαπημένων σας σταθμών σύροντάς τους. Μπορείτε επίσης να τους αφαιρέσετε από τη λίστα.",
  "stations.myLocation": "Η τοποθεσία μου",
  "stations.nearbyWeatherStations": "Κοντινοί καιρικοί σταθμοί",
  "stations.noLocationsFound": "Δεν βρέθηκαν τοποθεσίες",
  "stations.noSearchResults": "Κανένα άρθρο δεν ταιριάζει με την αναζήτησή σας",
  "stations.noStationsFound": "Δεν βρέθηκαν σταθμοί",
  "stations.noWeatherStationYet": "Δεν έχετε ακόμα μετεωρολογικό σταθμό",
  "stations.recentLocations": "Πρόσφατες",
  "stations.recentLocationsEmpty": "Το πρόσφατο ιστορικό σας είναι κενό.",
  "stations.removeFromFavorites": "Αφαίρεση από τα αγαπημένα",
  "stations.searchForLocation": "Αναζήτηση τοποθεσίας",
  "stations.searchForWeatherStation": "Αναζήτηση μετεωρολογικού σταθμού",
  "stations.searchResults": "Αποτελέσματα αναζήτησης",
  "stations.searchResultsEmpty": "Δεν βρέθηκαν αποτελέσματα.",
  "stations.searchResultsFound": "{count, plural, one {Βρέθηκε # αποτέλεσμα} other {Βρέθηκαν # αποτελέσματα}}",
  "stations.searchStationsDescription": "Εισαγάγετε μια πόλη, διεύθυνση ή όνομα τόπου για να βρείτε κοντινούς μετεωρολογικούς σταθμούς.",
  "stations.searchStationsHint": "Χρησιμοποιήστε τη γραμμή αναζήτησης παραπάνω για να ανακαλύψετε μετεωρολογικούς σταθμούς οπουδήποτε στον κόσμο.",
  "stations.selectStationForComparison": "Επιλέξτε ένα σταθμό για σύγκριση",
  "stations.stationAddedToFavorites": "Ο σταθμός προστέθηκε στα αγαπημένα",
  "stations.stationCount": "{count, plural, one {# σταθμός} other {# σταθμοί}}",
  "stations.stationInformation": "Πληροφορίες σταθμού",
  "stations.stationName": "Όνομα σταθμού",
  "stations.stationObservationsDescription": "Εμφάνιση των τελευταίων παρατηρήσεων από μετεωρολογικούς σταθμούς",
  "stations.stationRemovedFromFavorites": "Ο σταθμός αφαιρέθηκε από τα αγαπημένα",
  "stations.stationsNear": "Σταθμοί κοντά: {place}",
  "stations.stationType": "Τύπος σταθμού",
  "stations.statusOffline": "Εκτός σύνδεσης",
  "stations.statusOnline": "Συνδεδεμένο",
  "stations.statusStale": "Παλιό",
  "stations.tryAnotherLocation": "Δεν μπορέσαμε να βρούμε μετεωρολογικούς σταθμούς κοντά σε αυτή την τοποθεσία. Δοκιμάστε να αναζητήσετε σε διαφορετική περιοχή.",
  "stations.weatherStation": "Μετεωρολογικός σταθμός",
  "stations.weatherStationCount": "{count, plural, one {# μετεωρολογικός σταθμός} other {# μετεωρολογικοί σταθμοί}}",
  "stations.weatherStations": "Μετεωρολογικοί σταθμοί",
  "stations.welcomeConnectService": "Έχετε μετεωρολογικό σταθμό; Συνδέστε την υπηρεσία σας",
  "stations.welcomeSubtitle": "Ο καιρός σας, όλα σε ένα μέρος",
  "thermostat.away": "Εκτός σπιτιού",
  "thermostat.boilerOn": "Θέρμανση ΟΝ",
  "thermostat.hg": "Προστασία από παγετό",
  "thermostat.homeInformation": "Πληροφορίες για το σπίτι",
  "thermostat.homeName": "Όνομα σπιτιού",
  "thermostat.manualBoost": "Χειροκίνητη ενίσχυση",
  "thermostat.manualSetpointUntil": "Χειροκίνητο σημείο ρύθμισης μέχρι",
  "thermostat.noThermostatYet": "Δεν έχετε ακόμη θερμοστάτη",
  "thermostat.relay": "Ρελέ",
  "thermostat.room": "Δωμάτιο",
  "thermostat.rooms": "Δωμάτια",
  "thermostat.smartThermostat": "Έξυπνος θερμοστάτης",
  "thermostat.smartValve": "Έξυπνη βαλβίδα",
  "thermostat.whenBackHome": "Πότε θα επιστρέψετε στο σπίτι;",
  "units.celsius": "Κελσίου",
  "units.fahrenheit": "Φαρενάιτ",
  "units.inch": "Ίντσες",
  "units.inchOfMercury": "Ίντσες υδραργύρου",
  "units.kelvin": "Κέλβιν",
  "units.kilometerPerHour": "Χιλιόμετρα την ώρα",
  "units.knot": "Κόμβοι",
  "units.meterPerSecond": "Μέτρα το δευτερόλεπτο",
  "units.milePerHour": "Μίλια την ώρα",
  "units.millibar": "Μιλιμπάρ",
  "units.millimeter": "Χιλιοστά",
  "units.millimeterOfMercury": "Χιλιοστά υδραργύρου",
  "weatherConditions.blizzard": "Χιονοθύελλα",
  "weatherConditions.blowingDust": "Ανεμοδαρμένη σκόνη",
  "weatherConditions.blowingSnow": "Παρασυρόμενο χιόνι",
  "weatherConditions.breezy": "Ελαφρύς άνεμος",
  "weatherConditions.clear": "Αίθριος",
  "weatherConditions.cloudy": "Συννεφιά",
  "weatherConditions.drizzle": "Ψιχάλα",
  "weatherConditions.flurries": "Ασθενής χιονόπτωση",
  "weatherConditions.foggy": "Ομίχλη",
  "weatherConditions.freezingDrizzle": "Παγωμένη ψιχάλα",
  "weatherConditions.freezingRain": "Παγωμένη βροχή",
  "weatherConditions.frigid": "Δριμύ ψύχος",
  "weatherConditions.hail": "Χαλάζι",
  "weatherConditions.haze": "Αχλή",
  "weatherConditions.heavyRain": "Ισχυρή βροχή",
  "weatherConditions.heavySnow": "Ισχυρή χιονόπτωση",
  "weatherConditions.hot": "Ζέστη",
  "weatherConditions.hurricane": "Τυφώνας",
  "weatherConditions.isolatedThunderstorms": "Μεμονωμένες καταιγίδες",
  "weatherConditions.mixedRainAndHail": "Βροχή και χαλάζι",
  "weatherConditions.mostlyClear": "Κυρίως αίθριος",
  "weatherConditions.mostlyCloudy": "Κυρίως συννεφιά",
  "weatherConditions.mostlySunny": "Κυρίως ηλιόλουστος",
  "weatherConditions.notAvailable": "Οι καιρικές συνθήκες δεν είναι διαθέσιμες",
  "weatherConditions.partlyCloudy": "Μερική συννεφιά",
  "weatherConditions.rain": "Βροχή",
  "weatherConditions.rainSleet": "Βροχή και παγωμένοι κόκκοι",
  "weatherConditions.rainSnow": "Βροχή και χιόνι",
  "weatherConditions.scatteredShowers": "Διάσπαρτες μπόρες",
  "weatherConditions.scatteredSnowShowers": "Διάσπαρτες χιονομπόρες",
  "weatherConditions.scatteredThunderstorms": "Διάσπαρτες καταιγίδες",
  "weatherConditions.showers": "Μπόρες",
  "weatherConditions.sleet": "Παγωμένοι κόκκοι",
  "weatherConditions.smoke": "Καπνός",
  "weatherConditions.snow": "Χιόνι",
  "weatherConditions.snowShowers": "Χιονομπόρες",
  "weatherConditions.strongStorms": "Ισχυρές καταιγίδες",
  "weatherConditions.sunny": "Ηλιόλουστος",
  "weatherConditions.thunderstorms": "Καταιγίδες",
  "weatherConditions.tornado": "Ανεμοστρόβιλος",
  "weatherConditions.tropicalStorm": "Τροπική καταιγίδα",
  "weatherConditions.windy": "Ισχυρός άνεμος",
  "weatherConditions.wintryMix": "Μικτά χειμερινά κατακρημνίσματα",
  "weatherMap.legendHeavy": "Ισχυρή",
  "weatherMap.legendLight": "Ασθενής",
  "weatherMap.legendLightningHelp": "Το χρώμα δείχνει την ηλικία κάθε κεραυνού τα τελευταία {minutes} λεπτά — οι πιο πρόσφατοι με λευκό, οι παλαιότεροι με σκούρο κόκκινο.",
  "weatherMap.legendNewest": "Νεότερα",
  "weatherMap.legendOldest": "Παλαιότερα",
  "weatherMap.legendStationsHelp": "Το χρώμα του δείκτη αντικατοπτρίζει την τιμή της επιλεγμένης μέτρησης.",
  "weatherMap.lightningDataAttribution": "Δεδομένα κεραυνών: Blitzortung.org",
  "weatherMap.lightningStrikes": "Κεραυνοί",
  "weatherMap.lightningStrikesDescription": "Εμφάνιση κεραυνών σε πραγματικό χρόνο στον χάρτη",
  "weatherMap.mapLayers": "Επίπεδα χάρτη",
  "weatherMap.mapLegend": "Υπόμνημα χάρτη",
  "weatherMap.radarDataAttribution": "Δεδομένα ραντάρ: NOAA / EUMETNET OPERA via LibreWXR",
  "weatherMap.rainRadar": "Ραντάρ βροχής",
  "weatherMap.rainRadarDescription": "Εμφάνιση ραντάρ βροχής στον χάρτη",
  "weatherMap.weatherflowNCRain": "NC Rain (Nearcast Rain)",
  "weatherMap.weatherflowNCRainDescription": "Το NC Rain είναι μια πρόσθετη πηγή δεδομένων που παρέχεται μέσω του Tempest Weather System, το οποίο τροφοδοτείται από την τεχνολογία Nearcast. Τα δεδομένα NC Rain είναι μια εκτίμηση της μέσης συνολικής βροχόπτωσης γύρω από το Tempest σας σε επίπεδο περιοχής.",
  "weatherMap.weatherMap": "Χάρτης καιρού",
  "weatherMap.weatherMapMetaDescription": "Το SmartMixin παρέχει διαδραστικούς χάρτες καιρού και ραντάρ για καιρικές συνθήκες σε όλο τον κόσμο.",
  "weatherWarnings.activeNow": "Ενεργές τώρα",
  "weatherWarnings.fromTime": "Από {time}",
  "weatherWarnings.hazardAirQuality": "Ποιότητα αέρα",
  "weatherWarnings.hazardAvalanche": "Χιονοστιβάδες",
  "weatherWarnings.hazardCoastalEvent": "Παράκτιοι κίνδυνοι",
  "weatherWarnings.hazardFlood": "Πλημμύρες",
  "weatherWarnings.hazardFog": "Ομίχλη",
  "weatherWarnings.hazardForestFire": "Δασικές πυρκαγιές",
  "weatherWarnings.hazardHighTemperature": "Υψηλές θερμοκρασίες",
  "weatherWarnings.hazardLowTemperature": "Χαμηλές θερμοκρασίες",
  "weatherWarnings.hazardOther": "Άλλος κίνδυνος",
  "weatherWarnings.hazardRain": "Βροχή",
  "weatherWarnings.hazardSnowIce": "Χιόνι και παγετός",
  "weatherWarnings.hazardThunderstorm": "Καταιγίδες",
  "weatherWarnings.hazardUv": "Υπεριώδης ακτινοβολία",
  "weatherWarnings.hazardWind": "Άνεμος",
  "weatherWarnings.lastUpdate": "Τελευταία ενημέρωση: {time}",
  "weatherWarnings.severityExtreme": "Ακραίος",
  "weatherWarnings.severityFrom": "{severity} από {time}",
  "weatherWarnings.severityMinor": "Χαμηλός",
  "weatherWarnings.severityModerate": "Μέτριος",
  "weatherWarnings.severityNow": "{severity} τώρα",
  "weatherWarnings.severitySevere": "Σοβαρός",
  "weatherWarnings.severityUntil": "{severity} έως {time}",
  "weatherWarnings.source": "Πηγή: {source}",
  "weatherWarnings.spokenHazardOne": "{hazard}: {status}.",
  "weatherWarnings.spokenHazardTwo": "{hazard}: {first}, έπειτα {second}.",
  "weatherWarnings.spokenLabel": "{count, plural, one {# επίσημη προειδοποίηση καιρού} other {# επίσημες προειδοποιήσεις καιρού}}. {hazards}",
  "weatherWarnings.upcoming": "Επερχόμενες"
}
